"use strict";

var _typeof = require("@babel/runtime-corejs2/helpers/typeof");
var _Reflect$construct = require("@babel/runtime-corejs2/core-js/reflect/construct");
var _Object$keys2 = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _WeakMap = require("@babel/runtime-corejs2/core-js/weak-map");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime-corejs2/regenerator"));
var _set = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/set"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _keys = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/keys"));
var _values = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/values"));
require("core-js/modules/es6.number.constructor.js");
require("core-js/modules/es6.array.map.js");
require("core-js/modules/es6.function.name.js");
require("core-js/modules/es6.array.filter.js");
require("core-js/modules/es6.array.find.js");
require("core-js/modules/es6.string.includes.js");
require("core-js/modules/es7.array.includes.js");
var _extends2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/extends"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/asyncToGenerator"));
var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/toConsumableArray"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));
var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _axios = _interopRequireDefault(require("axios"));
var _stylingConstants = _interopRequireDefault(require("@gravity/styling-constants"));
var _dropdown = _interopRequireDefault(require("@gravity/dropdown"));
var _button = _interopRequireDefault(require("@gravity/button"));
var _product = require("@nucleo/product");
var _size = _interopRequireDefault(require("lodash/size"));
var _get = _interopRequireDefault(require("lodash/get"));
var _isEmpty = _interopRequireDefault(require("lodash/isEmpty"));
var _reactIntl = require("react-intl");
var _utils = require("@gravity/utils");
var _is_after = _interopRequireDefault(require("date-fns/is_after"));
var _format = _interopRequireDefault(require("date-fns/format"));
var _icon = _interopRequireDefault(require("@gravity/icon"));
var _polished = require("polished");
var _Styling = require("./Styling");
var _helpers = require("../../../../stx-widgets/v2/ProducerDashboard/helpers");
var _jsxFileName = "/codebuild/output/src1366864877/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/ReportManagement/lib/ReportManagement.js";
function _getRequireWildcardCache(e) { if ("function" != typeof _WeakMap) return null; var r = new _WeakMap(), t = new _WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = _Object$defineProperty && _Object$getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? _Object$getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? _Object$defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function cov_x7cnmwq6a() {
  var path = "/codebuild/output/src1366864877/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/ReportManagement/lib/ReportManagement.js";
  var hash = "e8e0af36c8631bb8b0fa121ebfe4999d83d6c135";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src1366864877/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/gravity/apps/tnwi/temp/functional/ReportManagement/lib/ReportManagement.js",
    statementMap: {
      "0": {
        start: {
          line: 37,
          column: 18
        },
        end: {
          line: 37,
          column: 34
        }
      },
      "1": {
        start: {
          line: 39,
          column: 33
        },
        end: {
          line: 50,
          column: 1
        }
      },
      "2": {
        start: {
          line: 46,
          column: 2
        },
        end: {
          line: 48,
          column: 3
        }
      },
      "3": {
        start: {
          line: 47,
          column: 4
        },
        end: {
          line: 47,
          column: 91
        }
      },
      "4": {
        start: {
          line: 49,
          column: 2
        },
        end: {
          line: 49,
          column: 87
        }
      },
      "5": {
        start: {
          line: 54,
          column: 4
        },
        end: {
          line: 63,
          column: 6
        }
      },
      "6": {
        start: {
          line: 67,
          column: 4
        },
        end: {
          line: 67,
          column: 17
        }
      },
      "7": {
        start: {
          line: 69,
          column: 25
        },
        end: {
          line: 69,
          column: 71
        }
      },
      "8": {
        start: {
          line: 70,
          column: 4
        },
        end: {
          line: 83,
          column: 6
        }
      },
      "9": {
        start: {
          line: 84,
          column: 4
        },
        end: {
          line: 84,
          column: 57
        }
      },
      "10": {
        start: {
          line: 85,
          column: 4
        },
        end: {
          line: 85,
          column: 83
        }
      },
      "11": {
        start: {
          line: 91,
          column: 4
        },
        end: {
          line: 96,
          column: 5
        }
      },
      "12": {
        start: {
          line: 92,
          column: 49
        },
        end: {
          line: 92,
          column: 94
        }
      },
      "13": {
        start: {
          line: 95,
          column: 6
        },
        end: {
          line: 95,
          column: 13
        }
      },
      "14": {
        start: {
          line: 98,
          column: 4
        },
        end: {
          line: 101,
          column: 8
        }
      },
      "15": {
        start: {
          line: 98,
          column: 28
        },
        end: {
          line: 101,
          column: 5
        }
      },
      "16": {
        start: {
          line: 107,
          column: 21
        },
        end: {
          line: 115,
          column: 3
        }
      },
      "17": {
        start: {
          line: 108,
          column: 4
        },
        end: {
          line: 110,
          column: 5
        }
      },
      "18": {
        start: {
          line: 109,
          column: 6
        },
        end: {
          line: 109,
          column: 13
        }
      },
      "19": {
        start: {
          line: 111,
          column: 4
        },
        end: {
          line: 113,
          column: 7
        }
      },
      "20": {
        start: {
          line: 114,
          column: 4
        },
        end: {
          line: 114,
          column: 85
        }
      },
      "21": {
        start: {
          line: 117,
          column: 26
        },
        end: {
          line: 136,
          column: 3
        }
      },
      "22": {
        start: {
          line: 118,
          column: 4
        },
        end: {
          line: 129,
          column: 5
        }
      },
      "23": {
        start: {
          line: 125,
          column: 6
        },
        end: {
          line: 127,
          column: 9
        }
      },
      "24": {
        start: {
          line: 128,
          column: 6
        },
        end: {
          line: 128,
          column: 13
        }
      },
      "25": {
        start: {
          line: 131,
          column: 33
        },
        end: {
          line: 131,
          column: 58
        }
      },
      "26": {
        start: {
          line: 132,
          column: 34
        },
        end: {
          line: 132,
          column: 44
        }
      },
      "27": {
        start: {
          line: 133,
          column: 20
        },
        end: {
          line: 133,
          column: 66
        }
      },
      "28": {
        start: {
          line: 135,
          column: 4
        },
        end: {
          line: 135,
          column: 45
        }
      },
      "29": {
        start: {
          line: 138,
          column: 22
        },
        end: {
          line: 151,
          column: 3
        }
      },
      "30": {
        start: {
          line: 139,
          column: 4
        },
        end: {
          line: 141,
          column: 5
        }
      },
      "31": {
        start: {
          line: 140,
          column: 6
        },
        end: {
          line: 140,
          column: 13
        }
      },
      "32": {
        start: {
          line: 142,
          column: 24
        },
        end: {
          line: 145,
          column: 5
        }
      },
      "33": {
        start: {
          line: 147,
          column: 4
        },
        end: {
          line: 149,
          column: 5
        }
      },
      "34": {
        start: {
          line: 148,
          column: 6
        },
        end: {
          line: 148,
          column: 32
        }
      },
      "35": {
        start: {
          line: 150,
          column: 4
        },
        end: {
          line: 150,
          column: 40
        }
      },
      "36": {
        start: {
          line: 154,
          column: 24
        },
        end: {
          line: 155,
          column: 93
        }
      },
      "37": {
        start: {
          line: 155,
          column: 4
        },
        end: {
          line: 155,
          column: 93
        }
      },
      "38": {
        start: {
          line: 155,
          column: 41
        },
        end: {
          line: 155,
          column: 89
        }
      },
      "39": {
        start: {
          line: 157,
          column: 21
        },
        end: {
          line: 158,
          column: 48
        }
      },
      "40": {
        start: {
          line: 158,
          column: 4
        },
        end: {
          line: 158,
          column: 48
        }
      },
      "41": {
        start: {
          line: 158,
          column: 34
        },
        end: {
          line: 158,
          column: 45
        }
      },
      "42": {
        start: {
          line: 160,
          column: 27
        },
        end: {
          line: 160,
          column: 74
        }
      },
      "43": {
        start: {
          line: 160,
          column: 39
        },
        end: {
          line: 160,
          column: 74
        }
      },
      "44": {
        start: {
          line: 160,
          column: 63
        },
        end: {
          line: 160,
          column: 73
        }
      },
      "45": {
        start: {
          line: 162,
          column: 30
        },
        end: {
          line: 167,
          column: 3
        }
      },
      "46": {
        start: {
          line: 163,
          column: 4
        },
        end: {
          line: 165,
          column: 5
        }
      },
      "47": {
        start: {
          line: 164,
          column: 6
        },
        end: {
          line: 164,
          column: 26
        }
      },
      "48": {
        start: {
          line: 166,
          column: 4
        },
        end: {
          line: 166,
          column: 74
        }
      },
      "49": {
        start: {
          line: 169,
          column: 37
        },
        end: {
          line: 194,
          column: 3
        }
      },
      "50": {
        start: {
          line: 170,
          column: 4
        },
        end: {
          line: 172,
          column: 5
        }
      },
      "51": {
        start: {
          line: 171,
          column: 6
        },
        end: {
          line: 171,
          column: 18
        }
      },
      "52": {
        start: {
          line: 173,
          column: 31
        },
        end: {
          line: 175,
          column: 12
        }
      },
      "53": {
        start: {
          line: 176,
          column: 30
        },
        end: {
          line: 176,
          column: 99
        }
      },
      "54": {
        start: {
          line: 177,
          column: 26
        },
        end: {
          line: 181,
          column: 12
        }
      },
      "55": {
        start: {
          line: 182,
          column: 25
        },
        end: {
          line: 186,
          column: 12
        }
      },
      "56": {
        start: {
          line: 187,
          column: 4
        },
        end: {
          line: 193,
          column: 6
        }
      },
      "57": {
        start: {
          line: 196,
          column: 28
        },
        end: {
          line: 228,
          column: 3
        }
      },
      "58": {
        start: {
          line: 198,
          column: 4
        },
        end: {
          line: 200,
          column: 5
        }
      },
      "59": {
        start: {
          line: 199,
          column: 6
        },
        end: {
          line: 199,
          column: 18
        }
      },
      "60": {
        start: {
          line: 203,
          column: 22
        },
        end: {
          line: 203,
          column: 71
        }
      },
      "61": {
        start: {
          line: 204,
          column: 28
        },
        end: {
          line: 204,
          column: 47
        }
      },
      "62": {
        start: {
          line: 206,
          column: 4
        },
        end: {
          line: 218,
          column: 5
        }
      },
      "63": {
        start: {
          line: 207,
          column: 6
        },
        end: {
          line: 207,
          column: 37
        }
      },
      "64": {
        start: {
          line: 209,
          column: 24
        },
        end: {
          line: 209,
          column: 42
        }
      },
      "65": {
        start: {
          line: 210,
          column: 32
        },
        end: {
          line: 212,
          column: 60
        }
      },
      "66": {
        start: {
          line: 213,
          column: 6
        },
        end: {
          line: 217,
          column: 8
        }
      },
      "67": {
        start: {
          line: 219,
          column: 4
        },
        end: {
          line: 227,
          column: 6
        }
      },
      "68": {
        start: {
          line: 230,
          column: 29
        },
        end: {
          line: 268,
          column: 3
        }
      },
      "69": {
        start: {
          line: 232,
          column: 4
        },
        end: {
          line: 234,
          column: 5
        }
      },
      "70": {
        start: {
          line: 233,
          column: 6
        },
        end: {
          line: 233,
          column: 18
        }
      },
      "71": {
        start: {
          line: 237,
          column: 22
        },
        end: {
          line: 237,
          column: 71
        }
      },
      "72": {
        start: {
          line: 238,
          column: 28
        },
        end: {
          line: 238,
          column: 47
        }
      },
      "73": {
        start: {
          line: 240,
          column: 4
        },
        end: {
          line: 258,
          column: 5
        }
      },
      "74": {
        start: {
          line: 241,
          column: 6
        },
        end: {
          line: 241,
          column: 37
        }
      },
      "75": {
        start: {
          line: 243,
          column: 25
        },
        end: {
          line: 243,
          column: 44
        }
      },
      "76": {
        start: {
          line: 244,
          column: 31
        },
        end: {
          line: 244,
          column: 91
        }
      },
      "77": {
        start: {
          line: 246,
          column: 8
        },
        end: {
          line: 252,
          column: 9
        }
      },
      "78": {
        start: {
          line: 253,
          column: 6
        },
        end: {
          line: 257,
          column: 8
        }
      },
      "79": {
        start: {
          line: 259,
          column: 4
        },
        end: {
          line: 267,
          column: 6
        }
      },
      "80": {
        start: {
          line: 270,
          column: 29
        },
        end: {
          line: 304,
          column: 3
        }
      },
      "81": {
        start: {
          line: 271,
          column: 26
        },
        end: {
          line: 271,
          column: 77
        }
      },
      "82": {
        start: {
          line: 272,
          column: 22
        },
        end: {
          line: 272,
          column: 126
        }
      },
      "83": {
        start: {
          line: 272,
          column: 64
        },
        end: {
          line: 272,
          column: 124
        }
      },
      "84": {
        start: {
          line: 272,
          column: 101
        },
        end: {
          line: 272,
          column: 123
        }
      },
      "85": {
        start: {
          line: 274,
          column: 4
        },
        end: {
          line: 276,
          column: 5
        }
      },
      "86": {
        start: {
          line: 275,
          column: 6
        },
        end: {
          line: 275,
          column: 18
        }
      },
      "87": {
        start: {
          line: 278,
          column: 22
        },
        end: {
          line: 278,
          column: 71
        }
      },
      "88": {
        start: {
          line: 279,
          column: 28
        },
        end: {
          line: 279,
          column: 47
        }
      },
      "89": {
        start: {
          line: 281,
          column: 4
        },
        end: {
          line: 294,
          column: 5
        }
      },
      "90": {
        start: {
          line: 282,
          column: 6
        },
        end: {
          line: 282,
          column: 37
        }
      },
      "91": {
        start: {
          line: 286,
          column: 6
        },
        end: {
          line: 293,
          column: 10
        }
      },
      "92": {
        start: {
          line: 295,
          column: 4
        },
        end: {
          line: 303,
          column: 6
        }
      },
      "93": {
        start: {
          line: 306,
          column: 20
        },
        end: {
          line: 312,
          column: 3
        }
      },
      "94": {
        start: {
          line: 307,
          column: 4
        },
        end: {
          line: 311,
          column: 26
        }
      },
      "95": {
        start: {
          line: 308,
          column: 59
        },
        end: {
          line: 308,
          column: 128
        }
      },
      "96": {
        start: {
          line: 315,
          column: 24
        },
        end: {
          line: 315,
          column: 83
        }
      },
      "97": {
        start: {
          line: 316,
          column: 4
        },
        end: {
          line: 316,
          column: 29
        }
      },
      "98": {
        start: {
          line: 322,
          column: 30
        },
        end: {
          line: 332,
          column: 3
        }
      },
      "99": {
        start: {
          line: 323,
          column: 32
        },
        end: {
          line: 325,
          column: 5
        }
      },
      "100": {
        start: {
          line: 324,
          column: 16
        },
        end: {
          line: 324,
          column: 60
        }
      },
      "101": {
        start: {
          line: 326,
          column: 4
        },
        end: {
          line: 331,
          column: 6
        }
      },
      "102": {
        start: {
          line: 334,
          column: 32
        },
        end: {
          line: 338,
          column: 3
        }
      },
      "103": {
        start: {
          line: 335,
          column: 4
        },
        end: {
          line: 337,
          column: 7
        }
      },
      "104": {
        start: {
          line: 340,
          column: 25
        },
        end: {
          line: 346,
          column: 3
        }
      },
      "105": {
        start: {
          line: 341,
          column: 4
        },
        end: {
          line: 345,
          column: 7
        }
      },
      "106": {
        start: {
          line: 348,
          column: 15
        },
        end: {
          line: 348,
          column: 67
        }
      },
      "107": {
        start: {
          line: 348,
          column: 23
        },
        end: {
          line: 348,
          column: 67
        }
      },
      "108": {
        start: {
          line: 350,
          column: 19
        },
        end: {
          line: 353,
          column: 3
        }
      },
      "109": {
        start: {
          line: 351,
          column: 17
        },
        end: {
          line: 351,
          column: 43
        }
      },
      "110": {
        start: {
          line: 352,
          column: 4
        },
        end: {
          line: 352,
          column: 69
        }
      },
      "111": {
        start: {
          line: 355,
          column: 15
        },
        end: {
          line: 357,
          column: 3
        }
      },
      "112": {
        start: {
          line: 356,
          column: 4
        },
        end: {
          line: 356,
          column: 85
        }
      },
      "113": {
        start: {
          line: 356,
          column: 31
        },
        end: {
          line: 356,
          column: 73
        }
      },
      "114": {
        start: {
          line: 370,
          column: 8
        },
        end: {
          line: 370,
          column: 18
        }
      },
      "115": {
        start: {
          line: 372,
          column: 55
        },
        end: {
          line: 372,
          column: 65
        }
      },
      "116": {
        start: {
          line: 374,
          column: 25
        },
        end: {
          line: 374,
          column: 47
        }
      },
      "117": {
        start: {
          line: 376,
          column: 18
        },
        end: {
          line: 376,
          column: 20
        }
      },
      "118": {
        start: {
          line: 377,
          column: 21
        },
        end: {
          line: 377,
          column: 23
        }
      },
      "119": {
        start: {
          line: 378,
          column: 25
        },
        end: {
          line: 378,
          column: 27
        }
      },
      "120": {
        start: {
          line: 379,
          column: 24
        },
        end: {
          line: 379,
          column: 28
        }
      },
      "121": {
        start: {
          line: 380,
          column: 22
        },
        end: {
          line: 380,
          column: 26
        }
      },
      "122": {
        start: {
          line: 381,
          column: 30
        },
        end: {
          line: 381,
          column: 34
        }
      },
      "123": {
        start: {
          line: 382,
          column: 26
        },
        end: {
          line: 382,
          column: 30
        }
      },
      "124": {
        start: {
          line: 383,
          column: 26
        },
        end: {
          line: 383,
          column: 30
        }
      },
      "125": {
        start: {
          line: 384,
          column: 23
        },
        end: {
          line: 384,
          column: 27
        }
      },
      "126": {
        start: {
          line: 385,
          column: 26
        },
        end: {
          line: 385,
          column: 34
        }
      },
      "127": {
        start: {
          line: 386,
          column: 33
        },
        end: {
          line: 386,
          column: 104
        }
      },
      "128": {
        start: {
          line: 387,
          column: 31
        },
        end: {
          line: 387,
          column: 100
        }
      },
      "129": {
        start: {
          line: 389,
          column: 4
        },
        end: {
          line: 397,
          column: 5
        }
      },
      "130": {
        start: {
          line: 390,
          column: 30
        },
        end: {
          line: 390,
          column: 81
        }
      },
      "131": {
        start: {
          line: 391,
          column: 6
        },
        end: {
          line: 396,
          column: 7
        }
      },
      "132": {
        start: {
          line: 392,
          column: 8
        },
        end: {
          line: 392,
          column: 54
        }
      },
      "133": {
        start: {
          line: 394,
          column: 8
        },
        end: {
          line: 394,
          column: 63
        }
      },
      "134": {
        start: {
          line: 395,
          column: 8
        },
        end: {
          line: 395,
          column: 95
        }
      },
      "135": {
        start: {
          line: 401,
          column: 4
        },
        end: {
          line: 404,
          column: 5
        }
      },
      "136": {
        start: {
          line: 402,
          column: 6
        },
        end: {
          line: 402,
          column: 66
        }
      },
      "137": {
        start: {
          line: 403,
          column: 6
        },
        end: {
          line: 403,
          column: 60
        }
      },
      "138": {
        start: {
          line: 407,
          column: 4
        },
        end: {
          line: 430,
          column: 5
        }
      },
      "139": {
        start: {
          line: 408,
          column: 6
        },
        end: {
          line: 408,
          column: 38
        }
      },
      "140": {
        start: {
          line: 410,
          column: 36
        },
        end: {
          line: 410,
          column: 60
        }
      },
      "141": {
        start: {
          line: 412,
          column: 6
        },
        end: {
          line: 429,
          column: 9
        }
      },
      "142": {
        start: {
          line: 421,
          column: 8
        },
        end: {
          line: 428,
          column: 9
        }
      },
      "143": {
        start: {
          line: 422,
          column: 10
        },
        end: {
          line: 422,
          column: 45
        }
      },
      "144": {
        start: {
          line: 425,
          column: 10
        },
        end: {
          line: 425,
          column: 49
        }
      },
      "145": {
        start: {
          line: 426,
          column: 10
        },
        end: {
          line: 426,
          column: 57
        }
      },
      "146": {
        start: {
          line: 427,
          column: 10
        },
        end: {
          line: 427,
          column: 43
        }
      },
      "147": {
        start: {
          line: 432,
          column: 28
        },
        end: {
          line: 432,
          column: 56
        }
      },
      "148": {
        start: {
          line: 433,
          column: 19
        },
        end: {
          line: 445,
          column: 5
        }
      },
      "149": {
        start: {
          line: 447,
          column: 4
        },
        end: {
          line: 447,
          column: 37
        }
      },
      "150": {
        start: {
          line: 450,
          column: 15
        },
        end: {
          line: 453,
          column: 3
        }
      },
      "151": {
        start: {
          line: 451,
          column: 4
        },
        end: {
          line: 451,
          column: 45
        }
      },
      "152": {
        start: {
          line: 452,
          column: 4
        },
        end: {
          line: 452,
          column: 25
        }
      },
      "153": {
        start: {
          line: 472,
          column: 8
        },
        end: {
          line: 472,
          column: 18
        }
      },
      "154": {
        start: {
          line: 480,
          column: 8
        },
        end: {
          line: 480,
          column: 18
        }
      },
      "155": {
        start: {
          line: 482,
          column: 36
        },
        end: {
          line: 482,
          column: 132
        }
      },
      "156": {
        start: {
          line: 482,
          column: 84
        },
        end: {
          line: 482,
          column: 131
        }
      },
      "157": {
        start: {
          line: 483,
          column: 20
        },
        end: {
          line: 506,
          column: 5
        }
      },
      "158": {
        start: {
          line: 509,
          column: 30
        },
        end: {
          line: 509,
          column: 54
        }
      },
      "159": {
        start: {
          line: 510,
          column: 31
        },
        end: {
          line: 510,
          column: 68
        }
      },
      "160": {
        start: {
          line: 514,
          column: 4
        },
        end: {
          line: 520,
          column: 5
        }
      },
      "161": {
        start: {
          line: 515,
          column: 6
        },
        end: {
          line: 515,
          column: 144
        }
      },
      "162": {
        start: {
          line: 516,
          column: 11
        },
        end: {
          line: 520,
          column: 5
        }
      },
      "163": {
        start: {
          line: 517,
          column: 6
        },
        end: {
          line: 517,
          column: 119
        }
      },
      "164": {
        start: {
          line: 519,
          column: 6
        },
        end: {
          line: 519,
          column: 105
        }
      },
      "165": {
        start: {
          line: 523,
          column: 32
        },
        end: {
          line: 523,
          column: 78
        }
      },
      "166": {
        start: {
          line: 525,
          column: 6
        },
        end: {
          line: 530,
          column: 8
        }
      },
      "167": {
        start: {
          line: 528,
          column: 36
        },
        end: {
          line: 528,
          column: 76
        }
      },
      "168": {
        start: {
          line: 534,
          column: 6
        },
        end: {
          line: 540,
          column: 8
        }
      },
      "169": {
        start: {
          line: 537,
          column: 36
        },
        end: {
          line: 537,
          column: 77
        }
      },
      "170": {
        start: {
          line: 544,
          column: 6
        },
        end: {
          line: 549,
          column: 20
        }
      },
      "171": {
        start: {
          line: 554,
          column: 6
        },
        end: {
          line: 556,
          column: 40
        }
      },
      "172": {
        start: {
          line: 559,
          column: 46
        },
        end: {
          line: 559,
          column: 96
        }
      },
      "173": {
        start: {
          line: 559,
          column: 55
        },
        end: {
          line: 559,
          column: 96
        }
      },
      "174": {
        start: {
          line: 561,
          column: 6
        },
        end: {
          line: 578,
          column: 24
        }
      },
      "175": {
        start: {
          line: 572,
          column: 12
        },
        end: {
          line: 574,
          column: 21
        }
      },
      "176": {
        start: {
          line: 581,
          column: 31
        },
        end: {
          line: 581,
          column: 114
        }
      },
      "177": {
        start: {
          line: 582,
          column: 37
        },
        end: {
          line: 582,
          column: 119
        }
      },
      "178": {
        start: {
          line: 585,
          column: 6
        },
        end: {
          line: 589,
          column: 33
        }
      },
      "179": {
        start: {
          line: 591,
          column: 30
        },
        end: {
          line: 591,
          column: 32
        }
      },
      "180": {
        start: {
          line: 592,
          column: 4
        },
        end: {
          line: 600,
          column: 5
        }
      },
      "181": {
        start: {
          line: 593,
          column: 6
        },
        end: {
          line: 593,
          column: 53
        }
      },
      "182": {
        start: {
          line: 594,
          column: 11
        },
        end: {
          line: 600,
          column: 5
        }
      },
      "183": {
        start: {
          line: 595,
          column: 6
        },
        end: {
          line: 595,
          column: 47
        }
      },
      "184": {
        start: {
          line: 596,
          column: 11
        },
        end: {
          line: 600,
          column: 5
        }
      },
      "185": {
        start: {
          line: 597,
          column: 6
        },
        end: {
          line: 597,
          column: 79
        }
      },
      "186": {
        start: {
          line: 598,
          column: 11
        },
        end: {
          line: 600,
          column: 5
        }
      },
      "187": {
        start: {
          line: 599,
          column: 6
        },
        end: {
          line: 599,
          column: 76
        }
      },
      "188": {
        start: {
          line: 603,
          column: 6
        },
        end: {
          line: 603,
          column: 93
        }
      },
      "189": {
        start: {
          line: 605,
          column: 6
        },
        end: {
          line: 609,
          column: 22
        }
      },
      "190": {
        start: {
          line: 606,
          column: 31
        },
        end: {
          line: 606,
          column: 97
        }
      },
      "191": {
        start: {
          line: 613,
          column: 6
        },
        end: {
          line: 613,
          column: 80
        }
      },
      "192": {
        start: {
          line: 617,
          column: 6
        },
        end: {
          line: 621,
          column: 22
        }
      },
      "193": {
        start: {
          line: 618,
          column: 31
        },
        end: {
          line: 618,
          column: 95
        }
      },
      "194": {
        start: {
          line: 625,
          column: 6
        },
        end: {
          line: 628,
          column: 19
        }
      },
      "195": {
        start: {
          line: 626,
          column: 50
        },
        end: {
          line: 626,
          column: 107
        }
      },
      "196": {
        start: {
          line: 632,
          column: 6
        },
        end: {
          line: 637,
          column: 23
        }
      },
      "197": {
        start: {
          line: 640,
          column: 4
        },
        end: {
          line: 676,
          column: 6
        }
      },
      "198": {
        start: {
          line: 680,
          column: 0
        },
        end: {
          line: 721,
          column: 2
        }
      },
      "199": {
        start: {
          line: 723,
          column: 0
        },
        end: {
          line: 741,
          column: 2
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 39,
            column: 33
          },
          end: {
            line: 39,
            column: 34
          }
        },
        loc: {
          start: {
            line: 45,
            column: 5
          },
          end: {
            line: 50,
            column: 1
          }
        },
        line: 45
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 53,
            column: 2
          },
          end: {
            line: 53,
            column: 3
          }
        },
        loc: {
          start: {
            line: 53,
            column: 51
          },
          end: {
            line: 64,
            column: 3
          }
        },
        line: 53
      },
      "2": {
        name: "(anonymous_2)",
        decl: {
          start: {
            line: 66,
            column: 2
          },
          end: {
            line: 66,
            column: 3
          }
        },
        loc: {
          start: {
            line: 66,
            column: 21
          },
          end: {
            line: 86,
            column: 3
          }
        },
        line: 66
      },
      "3": {
        name: "(anonymous_3)",
        decl: {
          start: {
            line: 88,
            column: 2
          },
          end: {
            line: 88,
            column: 3
          }
        },
        loc: {
          start: {
            line: 88,
            column: 23
          },
          end: {
            line: 102,
            column: 3
          }
        },
        line: 88
      },
      "4": {
        name: "(anonymous_4)",
        decl: {
          start: {
            line: 92,
            column: 39
          },
          end: {
            line: 92,
            column: 40
          }
        },
        loc: {
          start: {
            line: 92,
            column: 49
          },
          end: {
            line: 92,
            column: 94
          }
        },
        line: 92
      },
      "5": {
        name: "(anonymous_5)",
        decl: {
          start: {
            line: 98,
            column: 18
          },
          end: {
            line: 98,
            column: 19
          }
        },
        loc: {
          start: {
            line: 98,
            column: 28
          },
          end: {
            line: 101,
            column: 5
          }
        },
        line: 98
      },
      "6": {
        name: "(anonymous_6)",
        decl: {
          start: {
            line: 107,
            column: 21
          },
          end: {
            line: 107,
            column: 22
          }
        },
        loc: {
          start: {
            line: 107,
            column: 39
          },
          end: {
            line: 115,
            column: 3
          }
        },
        line: 107
      },
      "7": {
        name: "(anonymous_7)",
        decl: {
          start: {
            line: 117,
            column: 26
          },
          end: {
            line: 117,
            column: 27
          }
        },
        loc: {
          start: {
            line: 117,
            column: 64
          },
          end: {
            line: 136,
            column: 3
          }
        },
        line: 117
      },
      "8": {
        name: "(anonymous_8)",
        decl: {
          start: {
            line: 138,
            column: 22
          },
          end: {
            line: 138,
            column: 23
          }
        },
        loc: {
          start: {
            line: 138,
            column: 50
          },
          end: {
            line: 151,
            column: 3
          }
        },
        line: 138
      },
      "9": {
        name: "(anonymous_9)",
        decl: {
          start: {
            line: 154,
            column: 24
          },
          end: {
            line: 154,
            column: 25
          }
        },
        loc: {
          start: {
            line: 155,
            column: 4
          },
          end: {
            line: 155,
            column: 93
          }
        },
        line: 155
      },
      "10": {
        name: "(anonymous_10)",
        decl: {
          start: {
            line: 155,
            column: 29
          },
          end: {
            line: 155,
            column: 30
          }
        },
        loc: {
          start: {
            line: 155,
            column: 41
          },
          end: {
            line: 155,
            column: 89
          }
        },
        line: 155
      },
      "11": {
        name: "(anonymous_11)",
        decl: {
          start: {
            line: 157,
            column: 21
          },
          end: {
            line: 157,
            column: 22
          }
        },
        loc: {
          start: {
            line: 158,
            column: 4
          },
          end: {
            line: 158,
            column: 48
          }
        },
        line: 158
      },
      "12": {
        name: "(anonymous_12)",
        decl: {
          start: {
            line: 158,
            column: 26
          },
          end: {
            line: 158,
            column: 27
          }
        },
        loc: {
          start: {
            line: 158,
            column: 34
          },
          end: {
            line: 158,
            column: 45
          }
        },
        line: 158
      },
      "13": {
        name: "(anonymous_13)",
        decl: {
          start: {
            line: 160,
            column: 27
          },
          end: {
            line: 160,
            column: 28
          }
        },
        loc: {
          start: {
            line: 160,
            column: 39
          },
          end: {
            line: 160,
            column: 74
          }
        },
        line: 160
      },
      "14": {
        name: "(anonymous_14)",
        decl: {
          start: {
            line: 160,
            column: 52
          },
          end: {
            line: 160,
            column: 53
          }
        },
        loc: {
          start: {
            line: 160,
            column: 63
          },
          end: {
            line: 160,
            column: 73
          }
        },
        line: 160
      },
      "15": {
        name: "(anonymous_15)",
        decl: {
          start: {
            line: 162,
            column: 30
          },
          end: {
            line: 162,
            column: 31
          }
        },
        loc: {
          start: {
            line: 162,
            column: 41
          },
          end: {
            line: 167,
            column: 3
          }
        },
        line: 162
      },
      "16": {
        name: "(anonymous_16)",
        decl: {
          start: {
            line: 169,
            column: 37
          },
          end: {
            line: 169,
            column: 38
          }
        },
        loc: {
          start: {
            line: 169,
            column: 64
          },
          end: {
            line: 194,
            column: 3
          }
        },
        line: 169
      },
      "17": {
        name: "(anonymous_17)",
        decl: {
          start: {
            line: 196,
            column: 28
          },
          end: {
            line: 196,
            column: 29
          }
        },
        loc: {
          start: {
            line: 196,
            column: 82
          },
          end: {
            line: 228,
            column: 3
          }
        },
        line: 196
      },
      "18": {
        name: "(anonymous_18)",
        decl: {
          start: {
            line: 230,
            column: 29
          },
          end: {
            line: 230,
            column: 30
          }
        },
        loc: {
          start: {
            line: 230,
            column: 98
          },
          end: {
            line: 268,
            column: 3
          }
        },
        line: 230
      },
      "19": {
        name: "(anonymous_19)",
        decl: {
          start: {
            line: 270,
            column: 29
          },
          end: {
            line: 270,
            column: 30
          }
        },
        loc: {
          start: {
            line: 270,
            column: 122
          },
          end: {
            line: 304,
            column: 3
          }
        },
        line: 270
      },
      "20": {
        name: "(anonymous_20)",
        decl: {
          start: {
            line: 272,
            column: 48
          },
          end: {
            line: 272,
            column: 49
          }
        },
        loc: {
          start: {
            line: 272,
            column: 64
          },
          end: {
            line: 272,
            column: 124
          }
        },
        line: 272
      },
      "21": {
        name: "(anonymous_21)",
        decl: {
          start: {
            line: 272,
            column: 95
          },
          end: {
            line: 272,
            column: 96
          }
        },
        loc: {
          start: {
            line: 272,
            column: 101
          },
          end: {
            line: 272,
            column: 123
          }
        },
        line: 272
      },
      "22": {
        name: "(anonymous_22)",
        decl: {
          start: {
            line: 306,
            column: 20
          },
          end: {
            line: 306,
            column: 21
          }
        },
        loc: {
          start: {
            line: 307,
            column: 4
          },
          end: {
            line: 311,
            column: 26
          }
        },
        line: 307
      },
      "23": {
        name: "(anonymous_23)",
        decl: {
          start: {
            line: 308,
            column: 50
          },
          end: {
            line: 308,
            column: 51
          }
        },
        loc: {
          start: {
            line: 308,
            column: 59
          },
          end: {
            line: 308,
            column: 128
          }
        },
        line: 308
      },
      "24": {
        name: "(anonymous_24)",
        decl: {
          start: {
            line: 314,
            column: 2
          },
          end: {
            line: 314,
            column: 3
          }
        },
        loc: {
          start: {
            line: 314,
            column: 44
          },
          end: {
            line: 317,
            column: 3
          }
        },
        line: 314
      },
      "25": {
        name: "(anonymous_25)",
        decl: {
          start: {
            line: 322,
            column: 30
          },
          end: {
            line: 322,
            column: 31
          }
        },
        loc: {
          start: {
            line: 322,
            column: 42
          },
          end: {
            line: 332,
            column: 3
          }
        },
        line: 322
      },
      "26": {
        name: "(anonymous_26)",
        decl: {
          start: {
            line: 324,
            column: 6
          },
          end: {
            line: 324,
            column: 7
          }
        },
        loc: {
          start: {
            line: 324,
            column: 16
          },
          end: {
            line: 324,
            column: 60
          }
        },
        line: 324
      },
      "27": {
        name: "(anonymous_27)",
        decl: {
          start: {
            line: 334,
            column: 32
          },
          end: {
            line: 334,
            column: 33
          }
        },
        loc: {
          start: {
            line: 334,
            column: 42
          },
          end: {
            line: 338,
            column: 3
          }
        },
        line: 334
      },
      "28": {
        name: "(anonymous_28)",
        decl: {
          start: {
            line: 340,
            column: 25
          },
          end: {
            line: 340,
            column: 26
          }
        },
        loc: {
          start: {
            line: 340,
            column: 31
          },
          end: {
            line: 346,
            column: 3
          }
        },
        line: 340
      },
      "29": {
        name: "(anonymous_29)",
        decl: {
          start: {
            line: 348,
            column: 15
          },
          end: {
            line: 348,
            column: 16
          }
        },
        loc: {
          start: {
            line: 348,
            column: 23
          },
          end: {
            line: 348,
            column: 67
          }
        },
        line: 348
      },
      "30": {
        name: "(anonymous_30)",
        decl: {
          start: {
            line: 350,
            column: 19
          },
          end: {
            line: 350,
            column: 20
          }
        },
        loc: {
          start: {
            line: 350,
            column: 30
          },
          end: {
            line: 353,
            column: 3
          }
        },
        line: 350
      },
      "31": {
        name: "(anonymous_31)",
        decl: {
          start: {
            line: 355,
            column: 15
          },
          end: {
            line: 355,
            column: 16
          }
        },
        loc: {
          start: {
            line: 355,
            column: 43
          },
          end: {
            line: 357,
            column: 3
          }
        },
        line: 355
      },
      "32": {
        name: "(anonymous_32)",
        decl: {
          start: {
            line: 356,
            column: 18
          },
          end: {
            line: 356,
            column: 19
          }
        },
        loc: {
          start: {
            line: 356,
            column: 31
          },
          end: {
            line: 356,
            column: 73
          }
        },
        line: 356
      },
      "33": {
        name: "(anonymous_33)",
        decl: {
          start: {
            line: 359,
            column: 2
          },
          end: {
            line: 359,
            column: 3
          }
        },
        loc: {
          start: {
            line: 359,
            column: 57
          },
          end: {
            line: 448,
            column: 3
          }
        },
        line: 359
      },
      "34": {
        name: "(anonymous_34)",
        decl: {
          start: {
            line: 420,
            column: 14
          },
          end: {
            line: 420,
            column: 15
          }
        },
        loc: {
          start: {
            line: 420,
            column: 26
          },
          end: {
            line: 429,
            column: 7
          }
        },
        line: 420
      },
      "35": {
        name: "(anonymous_35)",
        decl: {
          start: {
            line: 450,
            column: 15
          },
          end: {
            line: 450,
            column: 16
          }
        },
        loc: {
          start: {
            line: 450,
            column: 21
          },
          end: {
            line: 453,
            column: 3
          }
        },
        line: 450
      },
      "36": {
        name: "(anonymous_36)",
        decl: {
          start: {
            line: 455,
            column: 2
          },
          end: {
            line: 455,
            column: 3
          }
        },
        loc: {
          start: {
            line: 455,
            column: 11
          },
          end: {
            line: 677,
            column: 3
          }
        },
        line: 455
      },
      "37": {
        name: "(anonymous_37)",
        decl: {
          start: {
            line: 482,
            column: 77
          },
          end: {
            line: 482,
            column: 78
          }
        },
        loc: {
          start: {
            line: 482,
            column: 84
          },
          end: {
            line: 482,
            column: 131
          }
        },
        line: 482
      },
      "38": {
        name: "(anonymous_38)",
        decl: {
          start: {
            line: 528,
            column: 22
          },
          end: {
            line: 528,
            column: 23
          }
        },
        loc: {
          start: {
            line: 528,
            column: 36
          },
          end: {
            line: 528,
            column: 76
          }
        },
        line: 528
      },
      "39": {
        name: "(anonymous_39)",
        decl: {
          start: {
            line: 537,
            column: 22
          },
          end: {
            line: 537,
            column: 23
          }
        },
        loc: {
          start: {
            line: 537,
            column: 36
          },
          end: {
            line: 537,
            column: 77
          }
        },
        line: 537
      },
      "40": {
        name: "(anonymous_40)",
        decl: {
          start: {
            line: 559,
            column: 46
          },
          end: {
            line: 559,
            column: 47
          }
        },
        loc: {
          start: {
            line: 559,
            column: 55
          },
          end: {
            line: 559,
            column: 96
          }
        },
        line: 559
      },
      "41": {
        name: "(anonymous_41)",
        decl: {
          start: {
            line: 571,
            column: 30
          },
          end: {
            line: 571,
            column: 31
          }
        },
        loc: {
          start: {
            line: 572,
            column: 12
          },
          end: {
            line: 574,
            column: 21
          }
        },
        line: 572
      },
      "42": {
        name: "(anonymous_42)",
        decl: {
          start: {
            line: 606,
            column: 25
          },
          end: {
            line: 606,
            column: 26
          }
        },
        loc: {
          start: {
            line: 606,
            column: 31
          },
          end: {
            line: 606,
            column: 97
          }
        },
        line: 606
      },
      "43": {
        name: "(anonymous_43)",
        decl: {
          start: {
            line: 618,
            column: 25
          },
          end: {
            line: 618,
            column: 26
          }
        },
        loc: {
          start: {
            line: 618,
            column: 31
          },
          end: {
            line: 618,
            column: 95
          }
        },
        line: 618
      },
      "44": {
        name: "(anonymous_44)",
        decl: {
          start: {
            line: 626,
            column: 41
          },
          end: {
            line: 626,
            column: 42
          }
        },
        loc: {
          start: {
            line: 626,
            column: 50
          },
          end: {
            line: 626,
            column: 107
          }
        },
        line: 626
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 46,
            column: 2
          },
          end: {
            line: 48,
            column: 3
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 46
      },
      "1": {
        loc: {
          start: {
            line: 47,
            column: 11
          },
          end: {
            line: 47,
            column: 90
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 47,
            column: 11
          },
          end: {
            line: 47,
            column: 35
          }
        }, {
          start: {
            line: 47,
            column: 39
          },
          end: {
            line: 47,
            column: 63
          }
        }, {
          start: {
            line: 47,
            column: 67
          },
          end: {
            line: 47,
            column: 90
          }
        }],
        line: 47
      },
      "2": {
        loc: {
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 49,
            column: 86
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 49,
            column: 9
          },
          end: {
            line: 49,
            column: 33
          }
        }, {
          start: {
            line: 49,
            column: 37
          },
          end: {
            line: 49,
            column: 61
          }
        }, {
          start: {
            line: 49,
            column: 65
          },
          end: {
            line: 49,
            column: 86
          }
        }],
        line: 49
      },
      "3": {
        loc: {
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 91,
            column: 4
          },
          end: {
            line: 96,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 91
      },
      "4": {
        loc: {
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 108,
            column: 4
          },
          end: {
            line: 110,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 108
      },
      "5": {
        loc: {
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 118,
            column: 4
          },
          end: {
            line: 129,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 118
      },
      "6": {
        loc: {
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 123,
            column: 26
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 119,
            column: 6
          },
          end: {
            line: 119,
            column: 26
          }
        }, {
          start: {
            line: 120,
            column: 6
          },
          end: {
            line: 120,
            column: 32
          }
        }, {
          start: {
            line: 121,
            column: 6
          },
          end: {
            line: 121,
            column: 35
          }
        }, {
          start: {
            line: 122,
            column: 6
          },
          end: {
            line: 122,
            column: 42
          }
        }, {
          start: {
            line: 123,
            column: 6
          },
          end: {
            line: 123,
            column: 26
          }
        }],
        line: 119
      },
      "7": {
        loc: {
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 141,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 139,
            column: 4
          },
          end: {
            line: 141,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 139
      },
      "8": {
        loc: {
          start: {
            line: 143,
            column: 7
          },
          end: {
            line: 143,
            column: 41
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 143,
            column: 20
          },
          end: {
            line: 143,
            column: 30
          }
        }, {
          start: {
            line: 143,
            column: 33
          },
          end: {
            line: 143,
            column: 41
          }
        }],
        line: 143
      },
      "9": {
        loc: {
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 149,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 147,
            column: 4
          },
          end: {
            line: 149,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 147
      },
      "10": {
        loc: {
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 147,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 147,
            column: 8
          },
          end: {
            line: 147,
            column: 18
          }
        }, {
          start: {
            line: 147,
            column: 22
          },
          end: {
            line: 147,
            column: 60
          }
        }],
        line: 147
      },
      "11": {
        loc: {
          start: {
            line: 155,
            column: 41
          },
          end: {
            line: 155,
            column: 89
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 155,
            column: 60
          },
          end: {
            line: 155,
            column: 76
          }
        }, {
          start: {
            line: 155,
            column: 79
          },
          end: {
            line: 155,
            column: 89
          }
        }],
        line: 155
      },
      "12": {
        loc: {
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 165,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 163,
            column: 4
          },
          end: {
            line: 165,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 163
      },
      "13": {
        loc: {
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 170,
            column: 4
          },
          end: {
            line: 172,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 170
      },
      "14": {
        loc: {
          start: {
            line: 173,
            column: 31
          },
          end: {
            line: 175,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 174,
            column: 8
          },
          end: {
            line: 174,
            column: 47
          }
        }, {
          start: {
            line: 175,
            column: 8
          },
          end: {
            line: 175,
            column: 12
          }
        }],
        line: 173
      },
      "15": {
        loc: {
          start: {
            line: 176,
            column: 30
          },
          end: {
            line: 176,
            column: 99
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 176,
            column: 54
          },
          end: {
            line: 176,
            column: 92
          }
        }, {
          start: {
            line: 176,
            column: 95
          },
          end: {
            line: 176,
            column: 99
          }
        }],
        line: 176
      },
      "16": {
        loc: {
          start: {
            line: 177,
            column: 26
          },
          end: {
            line: 181,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 178,
            column: 6
          },
          end: {
            line: 180,
            column: 13
          }
        }, {
          start: {
            line: 181,
            column: 8
          },
          end: {
            line: 181,
            column: 12
          }
        }],
        line: 177
      },
      "17": {
        loc: {
          start: {
            line: 182,
            column: 25
          },
          end: {
            line: 186,
            column: 12
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 183,
            column: 6
          },
          end: {
            line: 185,
            column: 13
          }
        }, {
          start: {
            line: 186,
            column: 8
          },
          end: {
            line: 186,
            column: 12
          }
        }],
        line: 182
      },
      "18": {
        loc: {
          start: {
            line: 187,
            column: 11
          },
          end: {
            line: 193,
            column: 5
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 188,
            column: 6
          },
          end: {
            line: 190,
            column: 13
          }
        }, {
          start: {
            line: 192,
            column: 6
          },
          end: {
            line: 192,
            column: 42
          }
        }],
        line: 187
      },
      "19": {
        loc: {
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 200,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 198,
            column: 4
          },
          end: {
            line: 200,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 198
      },
      "20": {
        loc: {
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 206,
            column: 4
          },
          end: {
            line: 218,
            column: 5
          }
        }, {
          start: {
            line: 208,
            column: 11
          },
          end: {
            line: 218,
            column: 5
          }
        }],
        line: 206
      },
      "21": {
        loc: {
          start: {
            line: 210,
            column: 32
          },
          end: {
            line: 212,
            column: 60
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 211,
            column: 11
          },
          end: {
            line: 211,
            column: 46
          }
        }, {
          start: {
            line: 212,
            column: 11
          },
          end: {
            line: 212,
            column: 59
          }
        }],
        line: 210
      },
      "22": {
        loc: {
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 232,
            column: 4
          },
          end: {
            line: 234,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 232
      },
      "23": {
        loc: {
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 232,
            column: 58
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 232,
            column: 8
          },
          end: {
            line: 232,
            column: 33
          }
        }, {
          start: {
            line: 232,
            column: 37
          },
          end: {
            line: 232,
            column: 58
          }
        }],
        line: 232
      },
      "24": {
        loc: {
          start: {
            line: 240,
            column: 4
          },
          end: {
            line: 258,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 240,
            column: 4
          },
          end: {
            line: 258,
            column: 5
          }
        }, {
          start: {
            line: 242,
            column: 11
          },
          end: {
            line: 258,
            column: 5
          }
        }],
        line: 240
      },
      "25": {
        loc: {
          start: {
            line: 246,
            column: 8
          },
          end: {
            line: 252,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 247,
            column: 10
          },
          end: {
            line: 247,
            column: 46
          }
        }, {
          start: {
            line: 249,
            column: 10
          },
          end: {
            line: 251,
            column: 17
          }
        }],
        line: 246
      },
      "26": {
        loc: {
          start: {
            line: 271,
            column: 26
          },
          end: {
            line: 271,
            column: 77
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 271,
            column: 51
          },
          end: {
            line: 271,
            column: 63
          }
        }, {
          start: {
            line: 271,
            column: 66
          },
          end: {
            line: 271,
            column: 77
          }
        }],
        line: 271
      },
      "27": {
        loc: {
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 276,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 274,
            column: 4
          },
          end: {
            line: 276,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 274
      },
      "28": {
        loc: {
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 294,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 281,
            column: 4
          },
          end: {
            line: 294,
            column: 5
          }
        }, {
          start: {
            line: 283,
            column: 11
          },
          end: {
            line: 294,
            column: 5
          }
        }],
        line: 281
      },
      "29": {
        loc: {
          start: {
            line: 287,
            column: 8
          },
          end: {
            line: 293,
            column: 9
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 288,
            column: 10
          },
          end: {
            line: 288,
            column: 73
          }
        }, {
          start: {
            line: 290,
            column: 10
          },
          end: {
            line: 292,
            column: 17
          }
        }],
        line: 287
      },
      "30": {
        loc: {
          start: {
            line: 310,
            column: 7
          },
          end: {
            line: 310,
            column: 48
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 310,
            column: 7
          },
          end: {
            line: 310,
            column: 19
          }
        }, {
          start: {
            line: 310,
            column: 23
          },
          end: {
            line: 310,
            column: 48
          }
        }],
        line: 310
      },
      "31": {
        loc: {
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 330,
            column: 67
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 327,
            column: 6
          },
          end: {
            line: 327,
            column: 26
          }
        }, {
          start: {
            line: 328,
            column: 6
          },
          end: {
            line: 328,
            column: 43
          }
        }, {
          start: {
            line: 329,
            column: 6
          },
          end: {
            line: 329,
            column: 67
          }
        }, {
          start: {
            line: 330,
            column: 6
          },
          end: {
            line: 330,
            column: 67
          }
        }],
        line: 327
      },
      "32": {
        loc: {
          start: {
            line: 386,
            column: 33
          },
          end: {
            line: 386,
            column: 104
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 386,
            column: 58
          },
          end: {
            line: 386,
            column: 97
          }
        }, {
          start: {
            line: 386,
            column: 100
          },
          end: {
            line: 386,
            column: 104
          }
        }],
        line: 386
      },
      "33": {
        loc: {
          start: {
            line: 387,
            column: 31
          },
          end: {
            line: 387,
            column: 100
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 387,
            column: 55
          },
          end: {
            line: 387,
            column: 93
          }
        }, {
          start: {
            line: 387,
            column: 96
          },
          end: {
            line: 387,
            column: 100
          }
        }],
        line: 387
      },
      "34": {
        loc: {
          start: {
            line: 389,
            column: 4
          },
          end: {
            line: 397,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 389,
            column: 4
          },
          end: {
            line: 397,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 389
      },
      "35": {
        loc: {
          start: {
            line: 389,
            column: 8
          },
          end: {
            line: 389,
            column: 83
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 389,
            column: 8
          },
          end: {
            line: 389,
            column: 34
          }
        }, {
          start: {
            line: 389,
            column: 39
          },
          end: {
            line: 389,
            column: 64
          }
        }, {
          start: {
            line: 389,
            column: 68
          },
          end: {
            line: 389,
            column: 82
          }
        }],
        line: 389
      },
      "36": {
        loc: {
          start: {
            line: 390,
            column: 30
          },
          end: {
            line: 390,
            column: 81
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 390,
            column: 55
          },
          end: {
            line: 390,
            column: 67
          }
        }, {
          start: {
            line: 390,
            column: 70
          },
          end: {
            line: 390,
            column: 81
          }
        }],
        line: 390
      },
      "37": {
        loc: {
          start: {
            line: 391,
            column: 6
          },
          end: {
            line: 396,
            column: 7
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 391,
            column: 6
          },
          end: {
            line: 396,
            column: 7
          }
        }, {
          start: {
            line: 393,
            column: 13
          },
          end: {
            line: 396,
            column: 7
          }
        }],
        line: 391
      },
      "38": {
        loc: {
          start: {
            line: 391,
            column: 9
          },
          end: {
            line: 391,
            column: 72
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 391,
            column: 9
          },
          end: {
            line: 391,
            column: 21
          }
        }, {
          start: {
            line: 391,
            column: 25
          },
          end: {
            line: 391,
            column: 72
          }
        }],
        line: 391
      },
      "39": {
        loc: {
          start: {
            line: 395,
            column: 25
          },
          end: {
            line: 395,
            column: 94
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 395,
            column: 49
          },
          end: {
            line: 395,
            column: 89
          }
        }, {
          start: {
            line: 395,
            column: 92
          },
          end: {
            line: 395,
            column: 94
          }
        }],
        line: 395
      },
      "40": {
        loc: {
          start: {
            line: 401,
            column: 4
          },
          end: {
            line: 404,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 401,
            column: 4
          },
          end: {
            line: 404,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 401
      },
      "41": {
        loc: {
          start: {
            line: 401,
            column: 8
          },
          end: {
            line: 401,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 401,
            column: 8
          },
          end: {
            line: 401,
            column: 29
          }
        }, {
          start: {
            line: 401,
            column: 34
          },
          end: {
            line: 401,
            column: 42
          }
        }, {
          start: {
            line: 401,
            column: 46
          },
          end: {
            line: 401,
            column: 52
          }
        }],
        line: 401
      },
      "42": {
        loc: {
          start: {
            line: 402,
            column: 22
          },
          end: {
            line: 402,
            column: 65
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 402,
            column: 33
          },
          end: {
            line: 402,
            column: 58
          }
        }, {
          start: {
            line: 402,
            column: 61
          },
          end: {
            line: 402,
            column: 65
          }
        }],
        line: 402
      },
      "43": {
        loc: {
          start: {
            line: 403,
            column: 20
          },
          end: {
            line: 403,
            column: 59
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 403,
            column: 29
          },
          end: {
            line: 403,
            column: 52
          }
        }, {
          start: {
            line: 403,
            column: 55
          },
          end: {
            line: 403,
            column: 59
          }
        }],
        line: 403
      },
      "44": {
        loc: {
          start: {
            line: 407,
            column: 4
          },
          end: {
            line: 430,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 407,
            column: 4
          },
          end: {
            line: 430,
            column: 5
          }
        }, {
          start: {
            line: 409,
            column: 11
          },
          end: {
            line: 430,
            column: 5
          }
        }],
        line: 407
      },
      "45": {
        loc: {
          start: {
            line: 407,
            column: 8
          },
          end: {
            line: 407,
            column: 50
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 407,
            column: 8
          },
          end: {
            line: 407,
            column: 33
          }
        }, {
          start: {
            line: 407,
            column: 37
          },
          end: {
            line: 407,
            column: 50
          }
        }],
        line: 407
      },
      "46": {
        loc: {
          start: {
            line: 421,
            column: 8
          },
          end: {
            line: 428,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 421,
            column: 8
          },
          end: {
            line: 428,
            column: 9
          }
        }, {
          start: {
            line: 423,
            column: 15
          },
          end: {
            line: 428,
            column: 9
          }
        }],
        line: 421
      },
      "47": {
        loc: {
          start: {
            line: 432,
            column: 28
          },
          end: {
            line: 432,
            column: 56
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 432,
            column: 28
          },
          end: {
            line: 432,
            column: 38
          }
        }, {
          start: {
            line: 432,
            column: 42
          },
          end: {
            line: 432,
            column: 56
          }
        }],
        line: 432
      },
      "48": {
        loc: {
          start: {
            line: 501,
            column: 31
          },
          end: {
            line: 502,
            column: 138
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 501,
            column: 32
          },
          end: {
            line: 501,
            column: 53
          }
        }, {
          start: {
            line: 501,
            column: 57
          },
          end: {
            line: 501,
            column: 72
          }
        }, {
          start: {
            line: 502,
            column: 8
          },
          end: {
            line: 502,
            column: 138
          }
        }],
        line: 501
      },
      "49": {
        loc: {
          start: {
            line: 502,
            column: 70
          },
          end: {
            line: 502,
            column: 134
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 502,
            column: 70
          },
          end: {
            line: 502,
            column: 93
          }
        }, {
          start: {
            line: 502,
            column: 97
          },
          end: {
            line: 502,
            column: 134
          }
        }],
        line: 502
      },
      "50": {
        loc: {
          start: {
            line: 514,
            column: 4
          },
          end: {
            line: 520,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 514,
            column: 4
          },
          end: {
            line: 520,
            column: 5
          }
        }, {
          start: {
            line: 516,
            column: 11
          },
          end: {
            line: 520,
            column: 5
          }
        }],
        line: 514
      },
      "51": {
        loc: {
          start: {
            line: 516,
            column: 11
          },
          end: {
            line: 520,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 516,
            column: 11
          },
          end: {
            line: 520,
            column: 5
          }
        }, {
          start: {
            line: 518,
            column: 11
          },
          end: {
            line: 520,
            column: 5
          }
        }],
        line: 516
      },
      "52": {
        loc: {
          start: {
            line: 539,
            column: 24
          },
          end: {
            line: 539,
            column: 53
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 539,
            column: 24
          },
          end: {
            line: 539,
            column: 41
          }
        }, {
          start: {
            line: 539,
            column: 45
          },
          end: {
            line: 539,
            column: 53
          }
        }],
        line: 539
      },
      "53": {
        loc: {
          start: {
            line: 546,
            column: 18
          },
          end: {
            line: 546,
            column: 60
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 546,
            column: 18
          },
          end: {
            line: 546,
            column: 36
          }
        }, {
          start: {
            line: 546,
            column: 40
          },
          end: {
            line: 546,
            column: 60
          }
        }],
        line: 546
      },
      "54": {
        loc: {
          start: {
            line: 576,
            column: 11
          },
          end: {
            line: 576,
            column: 91
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 576,
            column: 11
          },
          end: {
            line: 576,
            column: 37
          }
        }, {
          start: {
            line: 576,
            column: 41
          },
          end: {
            line: 576,
            column: 91
          }
        }],
        line: 576
      },
      "55": {
        loc: {
          start: {
            line: 585,
            column: 6
          },
          end: {
            line: 589,
            column: 33
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 585,
            column: 6
          },
          end: {
            line: 585,
            column: 23
          }
        }, {
          start: {
            line: 586,
            column: 6
          },
          end: {
            line: 586,
            column: 30
          }
        }, {
          start: {
            line: 587,
            column: 6
          },
          end: {
            line: 587,
            column: 31
          }
        }, {
          start: {
            line: 588,
            column: 6
          },
          end: {
            line: 588,
            column: 30
          }
        }, {
          start: {
            line: 589,
            column: 6
          },
          end: {
            line: 589,
            column: 33
          }
        }],
        line: 585
      },
      "56": {
        loc: {
          start: {
            line: 592,
            column: 4
          },
          end: {
            line: 600,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 592,
            column: 4
          },
          end: {
            line: 600,
            column: 5
          }
        }, {
          start: {
            line: 594,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        }],
        line: 592
      },
      "57": {
        loc: {
          start: {
            line: 594,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 594,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        }, {
          start: {
            line: 596,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        }],
        line: 594
      },
      "58": {
        loc: {
          start: {
            line: 596,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 596,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        }, {
          start: {
            line: 598,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        }],
        line: 596
      },
      "59": {
        loc: {
          start: {
            line: 598,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 598,
            column: 11
          },
          end: {
            line: 600,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 598
      },
      "60": {
        loc: {
          start: {
            line: 603,
            column: 6
          },
          end: {
            line: 603,
            column: 93
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 603,
            column: 6
          },
          end: {
            line: 603,
            column: 15
          }
        }, {
          start: {
            line: 603,
            column: 19
          },
          end: {
            line: 603,
            column: 45
          }
        }, {
          start: {
            line: 603,
            column: 49
          },
          end: {
            line: 603,
            column: 72
          }
        }, {
          start: {
            line: 603,
            column: 76
          },
          end: {
            line: 603,
            column: 93
          }
        }],
        line: 603
      },
      "61": {
        loc: {
          start: {
            line: 635,
            column: 9
          },
          end: {
            line: 635,
            column: 46
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 635,
            column: 9
          },
          end: {
            line: 635,
            column: 25
          }
        }, {
          start: {
            line: 635,
            column: 29
          },
          end: {
            line: 635,
            column: 46
          }
        }],
        line: 635
      },
      "62": {
        loc: {
          start: {
            line: 636,
            column: 9
          },
          end: {
            line: 636,
            column: 40
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 636,
            column: 9
          },
          end: {
            line: 636,
            column: 26
          }
        }, {
          start: {
            line: 636,
            column: 30
          },
          end: {
            line: 636,
            column: 40
          }
        }],
        line: 636
      },
      "63": {
        loc: {
          start: {
            line: 644,
            column: 9
          },
          end: {
            line: 646,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 644,
            column: 9
          },
          end: {
            line: 644,
            column: 27
          }
        }, {
          start: {
            line: 645,
            column: 10
          },
          end: {
            line: 645,
            column: 83
          }
        }],
        line: 644
      },
      "64": {
        loc: {
          start: {
            line: 648,
            column: 9
          },
          end: {
            line: 674,
            column: 9
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 648,
            column: 9
          },
          end: {
            line: 648,
            column: 26
          }
        }, {
          start: {
            line: 649,
            column: 10
          },
          end: {
            line: 673,
            column: 34
          }
        }],
        line: 648
      },
      "65": {
        loc: {
          start: {
            line: 672,
            column: 13
          },
          end: {
            line: 672,
            column: 51
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 672,
            column: 13
          },
          end: {
            line: 672,
            column: 33
          }
        }, {
          start: {
            line: 672,
            column: 37
          },
          end: {
            line: 672,
            column: 51
          }
        }],
        line: 672
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0,
      "45": 0,
      "46": 0,
      "47": 0,
      "48": 0,
      "49": 0,
      "50": 0,
      "51": 0,
      "52": 0,
      "53": 0,
      "54": 0,
      "55": 0,
      "56": 0,
      "57": 0,
      "58": 0,
      "59": 0,
      "60": 0,
      "61": 0,
      "62": 0,
      "63": 0,
      "64": 0,
      "65": 0,
      "66": 0,
      "67": 0,
      "68": 0,
      "69": 0,
      "70": 0,
      "71": 0,
      "72": 0,
      "73": 0,
      "74": 0,
      "75": 0,
      "76": 0,
      "77": 0,
      "78": 0,
      "79": 0,
      "80": 0,
      "81": 0,
      "82": 0,
      "83": 0,
      "84": 0,
      "85": 0,
      "86": 0,
      "87": 0,
      "88": 0,
      "89": 0,
      "90": 0,
      "91": 0,
      "92": 0,
      "93": 0,
      "94": 0,
      "95": 0,
      "96": 0,
      "97": 0,
      "98": 0,
      "99": 0,
      "100": 0,
      "101": 0,
      "102": 0,
      "103": 0,
      "104": 0,
      "105": 0,
      "106": 0,
      "107": 0,
      "108": 0,
      "109": 0,
      "110": 0,
      "111": 0,
      "112": 0,
      "113": 0,
      "114": 0,
      "115": 0,
      "116": 0,
      "117": 0,
      "118": 0,
      "119": 0,
      "120": 0,
      "121": 0,
      "122": 0,
      "123": 0,
      "124": 0,
      "125": 0,
      "126": 0,
      "127": 0,
      "128": 0,
      "129": 0,
      "130": 0,
      "131": 0,
      "132": 0,
      "133": 0,
      "134": 0,
      "135": 0,
      "136": 0,
      "137": 0,
      "138": 0,
      "139": 0,
      "140": 0,
      "141": 0,
      "142": 0,
      "143": 0,
      "144": 0,
      "145": 0,
      "146": 0,
      "147": 0,
      "148": 0,
      "149": 0,
      "150": 0,
      "151": 0,
      "152": 0,
      "153": 0,
      "154": 0,
      "155": 0,
      "156": 0,
      "157": 0,
      "158": 0,
      "159": 0,
      "160": 0,
      "161": 0,
      "162": 0,
      "163": 0,
      "164": 0,
      "165": 0,
      "166": 0,
      "167": 0,
      "168": 0,
      "169": 0,
      "170": 0,
      "171": 0,
      "172": 0,
      "173": 0,
      "174": 0,
      "175": 0,
      "176": 0,
      "177": 0,
      "178": 0,
      "179": 0,
      "180": 0,
      "181": 0,
      "182": 0,
      "183": 0,
      "184": 0,
      "185": 0,
      "186": 0,
      "187": 0,
      "188": 0,
      "189": 0,
      "190": 0,
      "191": 0,
      "192": 0,
      "193": 0,
      "194": 0,
      "195": 0,
      "196": 0,
      "197": 0,
      "198": 0,
      "199": 0
    },
    f: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0,
      "16": 0,
      "17": 0,
      "18": 0,
      "19": 0,
      "20": 0,
      "21": 0,
      "22": 0,
      "23": 0,
      "24": 0,
      "25": 0,
      "26": 0,
      "27": 0,
      "28": 0,
      "29": 0,
      "30": 0,
      "31": 0,
      "32": 0,
      "33": 0,
      "34": 0,
      "35": 0,
      "36": 0,
      "37": 0,
      "38": 0,
      "39": 0,
      "40": 0,
      "41": 0,
      "42": 0,
      "43": 0,
      "44": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0, 0],
      "2": [0, 0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0, 0, 0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0],
      "10": [0, 0],
      "11": [0, 0],
      "12": [0, 0],
      "13": [0, 0],
      "14": [0, 0],
      "15": [0, 0],
      "16": [0, 0],
      "17": [0, 0],
      "18": [0, 0],
      "19": [0, 0],
      "20": [0, 0],
      "21": [0, 0],
      "22": [0, 0],
      "23": [0, 0],
      "24": [0, 0],
      "25": [0, 0],
      "26": [0, 0],
      "27": [0, 0],
      "28": [0, 0],
      "29": [0, 0],
      "30": [0, 0],
      "31": [0, 0, 0, 0],
      "32": [0, 0],
      "33": [0, 0],
      "34": [0, 0],
      "35": [0, 0, 0],
      "36": [0, 0],
      "37": [0, 0],
      "38": [0, 0],
      "39": [0, 0],
      "40": [0, 0],
      "41": [0, 0, 0],
      "42": [0, 0],
      "43": [0, 0],
      "44": [0, 0],
      "45": [0, 0],
      "46": [0, 0],
      "47": [0, 0],
      "48": [0, 0, 0],
      "49": [0, 0],
      "50": [0, 0],
      "51": [0, 0],
      "52": [0, 0],
      "53": [0, 0],
      "54": [0, 0],
      "55": [0, 0, 0, 0, 0],
      "56": [0, 0],
      "57": [0, 0],
      "58": [0, 0],
      "59": [0, 0],
      "60": [0, 0, 0, 0],
      "61": [0, 0],
      "62": [0, 0],
      "63": [0, 0],
      "64": [0, 0],
      "65": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "e8e0af36c8631bb8b0fa121ebfe4999d83d6c135"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_x7cnmwq6a = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_x7cnmwq6a();
function ownKeys(e, r) { var t = _Object$keys2(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = _Reflect$construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_Reflect$construct) return false; if (_Reflect$construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(_Reflect$construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var _ref = (cov_x7cnmwq6a().s[0]++, _stylingConstants.default),
  color = _ref.color;
cov_x7cnmwq6a().s[1]++;
var updateAlertSelectProduct = function updateAlertSelectProduct(productType, mainProducts, subProducts, productRange, isShowAlertSelectProduct) {
  cov_x7cnmwq6a().f[0]++;
  cov_x7cnmwq6a().s[2]++;
  if (productType === 'EVENT') {
    cov_x7cnmwq6a().b[0][0]++;
    cov_x7cnmwq6a().s[3]++;
    return (cov_x7cnmwq6a().b[1][0]++, isShowAlertSelectProduct) && (cov_x7cnmwq6a().b[1][1]++, (0, _size.default)(mainProducts) === 0) && (cov_x7cnmwq6a().b[1][2]++, (0, _size.default)(subProducts) === 0);
  } else {
    cov_x7cnmwq6a().b[0][1]++;
  }
  cov_x7cnmwq6a().s[4]++;
  return (cov_x7cnmwq6a().b[2][0]++, isShowAlertSelectProduct) && (cov_x7cnmwq6a().b[2][1]++, (0, _size.default)(mainProducts) === 0) && (cov_x7cnmwq6a().b[2][2]++, (0, _isEmpty.default)(productRange));
};
var ReportManagement = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(ReportManagement, _PureComponent);
  var _super = _createSuper(ReportManagement);
  function ReportManagement(_props) {
    var _this;
    (0, _classCallCheck2.default)(this, ReportManagement);
    cov_x7cnmwq6a().f[2]++;
    cov_x7cnmwq6a().s[6]++;
    _this = _super.call(this, _props);
    /**
     * Update select report variant id
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onDropdownSelect", (cov_x7cnmwq6a().s[16]++, function (selectReportId) {
      cov_x7cnmwq6a().f[6]++;
      cov_x7cnmwq6a().s[17]++;
      if (!selectReportId) {
        cov_x7cnmwq6a().b[4][0]++;
        cov_x7cnmwq6a().s[18]++;
        return;
      } else {
        cov_x7cnmwq6a().b[4][1]++;
      }
      cov_x7cnmwq6a().s[19]++;
      _this.mergeState({
        selectReportId: Number(selectReportId)
      });
      cov_x7cnmwq6a().s[20]++;
      _this.changeDisplayAlertOrderDate(_this.isShouldDisableDateFilter(selectReportId));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onGenerateButtonClick", (cov_x7cnmwq6a().s[21]++, function (exportType, isDisableGenerateBtn) {
      cov_x7cnmwq6a().f[7]++;
      cov_x7cnmwq6a().s[22]++;
      if ((cov_x7cnmwq6a().b[6][0]++, _this.props.isDisable) || (cov_x7cnmwq6a().b[6][1]++, !_this.state.selectReportId) || (cov_x7cnmwq6a().b[6][2]++, !_this.props.reportGenerateUrl) || (cov_x7cnmwq6a().b[6][3]++, _this.props.isNoneProductWereSelected) || (cov_x7cnmwq6a().b[6][4]++, isDisableGenerateBtn)) {
        cov_x7cnmwq6a().b[5][0]++;
        cov_x7cnmwq6a().s[23]++;
        _this.mergeState({
          isShowAlertSelectProduct: _this.props.isNoneProductWereSelected
        });
        cov_x7cnmwq6a().s[24]++;
        return;
      } else {
        cov_x7cnmwq6a().b[5][1]++;
      }
      var reportVariantIdParam = (cov_x7cnmwq6a().s[25]++, _this.state.selectReportId);
      var _ref2 = (cov_x7cnmwq6a().s[26]++, _this.props),
        reportGenerateUrl = _ref2.reportGenerateUrl;
      var urlPath = (cov_x7cnmwq6a().s[27]++, "".concat(reportGenerateUrl, "/").concat(reportVariantIdParam));
      cov_x7cnmwq6a().s[28]++;
      _this.generateReport(exportType, urlPath);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "onChangeOrderDate", (cov_x7cnmwq6a().s[29]++, function (updateDate, isDateFrom) {
      cov_x7cnmwq6a().f[8]++;
      cov_x7cnmwq6a().s[30]++;
      if (!updateDate) {
        cov_x7cnmwq6a().b[7][0]++;
        cov_x7cnmwq6a().s[31]++;
        return;
      } else {
        cov_x7cnmwq6a().b[7][1]++;
      }
      var updateState = (cov_x7cnmwq6a().s[32]++, (0, _defineProperty2.default)((0, _defineProperty2.default)({}, isDateFrom ? (cov_x7cnmwq6a().b[8][0]++, 'dateFrom') : (cov_x7cnmwq6a().b[8][1]++, 'dateTo'), updateDate), "isOrderDateChange", true));
      // Clear "date to" if new "date from" after current "date to"
      cov_x7cnmwq6a().s[33]++;
      if ((cov_x7cnmwq6a().b[10][0]++, isDateFrom) && (cov_x7cnmwq6a().b[10][1]++, (0, _is_after.default)(updateDate, _this.state.dateTo))) {
        cov_x7cnmwq6a().b[9][0]++;
        cov_x7cnmwq6a().s[34]++;
        updateState.dateTo = null;
      } else {
        cov_x7cnmwq6a().b[9][1]++;
      }
      cov_x7cnmwq6a().s[35]++;
      _this.mergeState(_objectSpread({}, updateState));
    }));
    // Using Set to avoid duplicate id
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getProductIdsForUrl", (cov_x7cnmwq6a().s[36]++, function (products) {
      cov_x7cnmwq6a().f[9]++;
      cov_x7cnmwq6a().s[37]++;
      return (0, _toConsumableArray2.default)(new _set.default(products.map(function (product) {
        cov_x7cnmwq6a().f[10]++;
        cov_x7cnmwq6a().s[38]++;
        return product.parentId ? (cov_x7cnmwq6a().b[11][0]++, product.parentId) : (cov_x7cnmwq6a().b[11][1]++, product.id);
      })));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getTourIdsForUrl", (cov_x7cnmwq6a().s[39]++, function (tours) {
      cov_x7cnmwq6a().f[11]++;
      cov_x7cnmwq6a().s[40]++;
      return (0, _toConsumableArray2.default)(new _set.default(tours.map(function (tour) {
        cov_x7cnmwq6a().f[12]++;
        cov_x7cnmwq6a().s[41]++;
        return tour.tourId;
      })));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getSubProductIdsForUrl", (cov_x7cnmwq6a().s[42]++, function (products) {
      cov_x7cnmwq6a().f[13]++;
      cov_x7cnmwq6a().s[43]++;
      return products.map(function (product) {
        cov_x7cnmwq6a().f[14]++;
        cov_x7cnmwq6a().s[44]++;
        return product.id;
      });
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getReportProductShortName", (cov_x7cnmwq6a().s[45]++, function (product) {
      cov_x7cnmwq6a().f[15]++;
      cov_x7cnmwq6a().s[46]++;
      if (!product.parentName) {
        cov_x7cnmwq6a().b[12][0]++;
        cov_x7cnmwq6a().s[47]++;
        return product.name;
      } else {
        cov_x7cnmwq6a().b[12][1]++;
      }
      cov_x7cnmwq6a().s[48]++;
      return "".concat(product.parentName, " - ").concat(_this.formatDateTime(product.date));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getReportVisitDateRangeShortName", (cov_x7cnmwq6a().s[49]++, function (productRange, message) {
      cov_x7cnmwq6a().f[16]++;
      cov_x7cnmwq6a().s[50]++;
      if ((0, _isEmpty.default)(productRange)) {
        cov_x7cnmwq6a().b[13][0]++;
        cov_x7cnmwq6a().s[51]++;
        return null;
      } else {
        cov_x7cnmwq6a().b[13][1]++;
      }
      var firstDateFormatted = (cov_x7cnmwq6a().s[52]++, productRange.firstDate ? (cov_x7cnmwq6a().b[14][0]++, _this.formatDate(productRange.firstDate)) : (cov_x7cnmwq6a().b[14][1]++, null));
      var lastDateFormatted = (cov_x7cnmwq6a().s[53]++, productRange.lastDate ? (cov_x7cnmwq6a().b[15][0]++, _this.formatDate(productRange.lastDate)) : (cov_x7cnmwq6a().b[15][1]++, null));
      var firstDateText = (cov_x7cnmwq6a().s[54]++, firstDateFormatted ? (cov_x7cnmwq6a().b[16][0]++, /*#__PURE__*/_react.default.createElement("span", {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 178,
          columnNumber: 7
        }
      }, message.from, " ", firstDateFormatted)) : (cov_x7cnmwq6a().b[16][1]++, null));
      var lastDateText = (cov_x7cnmwq6a().s[55]++, lastDateFormatted ? (cov_x7cnmwq6a().b[17][0]++, /*#__PURE__*/_react.default.createElement("span", {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 183,
          columnNumber: 7
        }
      }, message.to, " ", lastDateFormatted)) : (cov_x7cnmwq6a().b[17][1]++, null));
      cov_x7cnmwq6a().s[56]++;
      return productRange.firstDate !== productRange.lastDate ? (cov_x7cnmwq6a().b[18][0]++, /*#__PURE__*/_react.default.createElement("span", {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 188,
          columnNumber: 7
        }
      }, "- ", firstDateText, " ", lastDateText, ' ')) : (cov_x7cnmwq6a().b[18][1]++, /*#__PURE__*/_react.default.createElement("span", {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 192,
          columnNumber: 7
        }
      }, "- ", firstDateFormatted, " "));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getReportSummaryForPass", (cov_x7cnmwq6a().s[57]++, function (passProducts, message, isAllProductsWereSelected) {
      cov_x7cnmwq6a().f[17]++;
      cov_x7cnmwq6a().s[58]++;
      // Not display item summary if not have any item
      if ((0, _size.default)(passProducts) === 0) {
        cov_x7cnmwq6a().b[19][0]++;
        cov_x7cnmwq6a().s[59]++;
        return null;
      } else {
        cov_x7cnmwq6a().b[19][1]++;
      }
      var summaryText;
      var arrowIcon = (cov_x7cnmwq6a().s[60]++, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 15,
        iconName: "chevron-double-down",
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 203,
          columnNumber: 23
        }
      }));
      var generateForText = (cov_x7cnmwq6a().s[61]++, message.generateFor);
      cov_x7cnmwq6a().s[62]++;
      if (isAllProductsWereSelected) {
        cov_x7cnmwq6a().b[20][0]++;
        cov_x7cnmwq6a().s[63]++;
        summaryText = message.allItems;
      } else {
        cov_x7cnmwq6a().b[20][1]++;
        var passCount = (cov_x7cnmwq6a().s[64]++, (0, _size.default)(passProducts));
        var passesSummaryText = (cov_x7cnmwq6a().s[65]++, passCount === 1 ? (cov_x7cnmwq6a().b[21][0]++, /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 211,
            columnNumber: 12
          }
        }, passProducts[0].name)) : (cov_x7cnmwq6a().b[21][1]++, /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 212,
            columnNumber: 12
          }
        }, passCount, " ", message.selectedItems)));
        cov_x7cnmwq6a().s[66]++;
        summaryText = /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 214,
            columnNumber: 9
          }
        }, passesSummaryText);
      }
      cov_x7cnmwq6a().s[67]++;
      return /*#__PURE__*/_react.default.createElement(_Styling.ReportSummaryWrapper, {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 220,
          columnNumber: 7
        }
      }, arrowIcon, ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: 'summary-text',
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 222,
          columnNumber: 9
        }
      }, ' ', generateForText, ": ", summaryText, ' '));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getReportSummaryForVisit", (cov_x7cnmwq6a().s[68]++, function (visitProducts, productRange, message, isAllProductsWereSelected) {
      cov_x7cnmwq6a().f[18]++;
      cov_x7cnmwq6a().s[69]++;
      // Not display item summary if not have any item
      if ((cov_x7cnmwq6a().b[23][0]++, (0, _size.default)(visitProducts) === 0) && (cov_x7cnmwq6a().b[23][1]++, (0, _isEmpty.default)(productRange))) {
        cov_x7cnmwq6a().b[22][0]++;
        cov_x7cnmwq6a().s[70]++;
        return null;
      } else {
        cov_x7cnmwq6a().b[22][1]++;
      }
      var summaryText;
      var arrowIcon = (cov_x7cnmwq6a().s[71]++, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 15,
        iconName: "chevron-double-down",
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 237,
          columnNumber: 23
        }
      }));
      var generateForText = (cov_x7cnmwq6a().s[72]++, message.generateFor);
      cov_x7cnmwq6a().s[73]++;
      if (isAllProductsWereSelected) {
        cov_x7cnmwq6a().b[24][0]++;
        cov_x7cnmwq6a().s[74]++;
        summaryText = message.allItems;
      } else {
        cov_x7cnmwq6a().b[24][1]++;
        var visitCount = (cov_x7cnmwq6a().s[75]++, (0, _size.default)(visitProducts));
        var dateRangeMessage = (cov_x7cnmwq6a().s[76]++, _this.getReportVisitDateRangeShortName(productRange, message));
        var visitSummaryText = (cov_x7cnmwq6a().s[77]++, visitCount === 1 ? (cov_x7cnmwq6a().b[25][0]++, /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 247,
            columnNumber: 11
          }
        }, visitProducts[0].name)) : (cov_x7cnmwq6a().b[25][1]++, /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 249,
            columnNumber: 11
          }
        }, visitCount, " ", message.selectedItems)));
        cov_x7cnmwq6a().s[78]++;
        summaryText = /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 254,
            columnNumber: 9
          }
        }, visitSummaryText, " ", dateRangeMessage);
      }
      cov_x7cnmwq6a().s[79]++;
      return /*#__PURE__*/_react.default.createElement(_Styling.ReportSummaryWrapper, {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 260,
          columnNumber: 7
        }
      }, arrowIcon, ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: 'summary-text',
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 262,
          columnNumber: 9
        }
      }, ' ', generateForText, ": ", summaryText, ' '));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getReportSummaryForEvent", (cov_x7cnmwq6a().s[80]++, function (mainProducts, subProducts, message, isAllProductsWereSelected, unselectedPerformanceIds) {
      cov_x7cnmwq6a().f[19]++;
      var finalProducts = (cov_x7cnmwq6a().s[81]++, (0, _size.default)(mainProducts) > 0 ? (cov_x7cnmwq6a().b[26][0]++, mainProducts) : (cov_x7cnmwq6a().b[26][1]++, subProducts));
      var itemCount = (cov_x7cnmwq6a().s[82]++, (0, _size.default)(finalProducts.filter(function (finalProduct) {
        cov_x7cnmwq6a().f[20]++;
        cov_x7cnmwq6a().s[83]++;
        return unselectedPerformanceIds.every(function (id) {
          cov_x7cnmwq6a().f[21]++;
          cov_x7cnmwq6a().s[84]++;
          return id !== finalProduct.id;
        });
      })));
      // Not display item summary if not have any item
      cov_x7cnmwq6a().s[85]++;
      if (itemCount === 0) {
        cov_x7cnmwq6a().b[27][0]++;
        cov_x7cnmwq6a().s[86]++;
        return null;
      } else {
        cov_x7cnmwq6a().b[27][1]++;
      }
      var summaryText;
      var arrowIcon = (cov_x7cnmwq6a().s[87]++, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 15,
        iconName: "chevron-double-down",
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 278,
          columnNumber: 23
        }
      }));
      var generateForText = (cov_x7cnmwq6a().s[88]++, message.generateFor);
      cov_x7cnmwq6a().s[89]++;
      if (isAllProductsWereSelected) {
        cov_x7cnmwq6a().b[28][0]++;
        cov_x7cnmwq6a().s[90]++;
        summaryText = message.allItems;
      } else {
        cov_x7cnmwq6a().b[28][1]++;
        cov_x7cnmwq6a().s[91]++;
        // Just have only 1 item => display item name
        // More 1 item => display number items
        summaryText = itemCount === 1 ? (cov_x7cnmwq6a().b[29][0]++, /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 288,
            columnNumber: 11
          }
        }, _this.getReportProductShortName(finalProducts[0]))) : (cov_x7cnmwq6a().b[29][1]++, /*#__PURE__*/_react.default.createElement("span", {
          __self: (0, _assertThisInitialized2.default)(_this),
          __source: {
            fileName: _jsxFileName,
            lineNumber: 290,
            columnNumber: 11
          }
        }, itemCount, " ", message.selectedItems));
      }
      cov_x7cnmwq6a().s[92]++;
      return /*#__PURE__*/_react.default.createElement(_Styling.ReportSummaryWrapper, {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 296,
          columnNumber: 7
        }
      }, arrowIcon, ' ', /*#__PURE__*/_react.default.createElement("span", {
        className: 'summary-text',
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 298,
          columnNumber: 9
        }
      }, ' ', generateForText, ": ", summaryText, ' '));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "getAlertMessage", (cov_x7cnmwq6a().s[93]++, function (message, additionInfo) {
      cov_x7cnmwq6a().f[22]++;
      cov_x7cnmwq6a().s[94]++;
      return /*#__PURE__*/_react.default.createElement(_Styling.AlertMessageWrapper, {
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 307,
          columnNumber: 5
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 20,
        iconName: "error",
        iconColor: function iconColor(props) {
          cov_x7cnmwq6a().f[23]++;
          cov_x7cnmwq6a().s[95]++;
          return (0, _get.default)(props.theme, 'dashboard.titleTextColor', (0, _polished.darken)(0.3, color.info));
        },
        __self: (0, _assertThisInitialized2.default)(_this),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 308,
          columnNumber: 7
        }
      }), message, (cov_x7cnmwq6a().b[30][0]++, additionInfo) && (cov_x7cnmwq6a().b[30][1]++, "\xA0(".concat(additionInfo, ")")));
    }));
    /**
     * Return TRUE if report does not have order date params
     */
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "isShouldDisableDateFilter", (cov_x7cnmwq6a().s[98]++, function (reportId) {
      cov_x7cnmwq6a().f[25]++;
      var selectReportVariant = (cov_x7cnmwq6a().s[99]++, _this.props.reportVariants.find(function (report) {
        cov_x7cnmwq6a().f[26]++;
        cov_x7cnmwq6a().s[100]++;
        return String(report.reportId) === String(reportId);
      }));
      cov_x7cnmwq6a().s[101]++;
      return (cov_x7cnmwq6a().b[31][0]++, !selectReportVariant) || (cov_x7cnmwq6a().b[31][1]++, !selectReportVariant.reportParameters) || (cov_x7cnmwq6a().b[31][2]++, !selectReportVariant.reportParameters.includes('orderDateFr')) || (cov_x7cnmwq6a().b[31][3]++, !selectReportVariant.reportParameters.includes('orderDateTo'));
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "changeDisplayAlertOrderDate", (cov_x7cnmwq6a().s[102]++, function (isShow) {
      cov_x7cnmwq6a().f[27]++;
      cov_x7cnmwq6a().s[103]++;
      _this.mergeState({
        isShowAlertOrderDate: isShow
      });
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "resetOrderDateFilter", (cov_x7cnmwq6a().s[104]++, function () {
      cov_x7cnmwq6a().f[28]++;
      cov_x7cnmwq6a().s[105]++;
      _this.mergeState({
        dateFrom: null,
        dateTo: null,
        isOrderDateChange: false
      });
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "formatDate", (cov_x7cnmwq6a().s[106]++, function (date) {
      cov_x7cnmwq6a().f[29]++;
      cov_x7cnmwq6a().s[107]++;
      return (0, _format.default)((0, _utils.convertToUtcDate)(date), 'DD.MM.YYYY');
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "formatDateTime", (cov_x7cnmwq6a().s[108]++, function (dateTime) {
      cov_x7cnmwq6a().f[30]++;
      var date = (cov_x7cnmwq6a().s[109]++, (0, _utils.convertToUtcDate)(dateTime));
      cov_x7cnmwq6a().s[110]++;
      return (0, _format.default)(date, 'MM/DD/YYYY - hh:mm A', {
        timeZone: 'UTC'
      });
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "mergeState", (cov_x7cnmwq6a().s[111]++, function (partialState, callBack) {
      cov_x7cnmwq6a().f[31]++;
      cov_x7cnmwq6a().s[112]++;
      _this.setState(function (prevState) {
        cov_x7cnmwq6a().f[32]++;
        cov_x7cnmwq6a().s[113]++;
        return (0, _assign.default)({}, prevState, partialState);
      }, callBack);
    }));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "toggleHelp", (cov_x7cnmwq6a().s[150]++, function () {
      cov_x7cnmwq6a().f[35]++;
      cov_x7cnmwq6a().s[151]++;
      window.jQuery('body').chardinJs('start');
      cov_x7cnmwq6a().s[152]++;
      window.scrollTo(0, 0);
    }));
    var initReportId = (cov_x7cnmwq6a().s[7]++, (0, _get.default)(_props, 'reportVariants[0].reportId', null));
    cov_x7cnmwq6a().s[8]++;
    _this.state = {
      // set default report variant => first element
      selectReportId: initReportId,
      // Should show alert select at least product
      isShowAlertSelectProduct: false,
      // check right here to display message when init components
      isShowAlertOrderDate: _this.isShouldDisableDateFilter(initReportId),
      // Use to check disable or enable reset button
      isOrderDateChange: false,
      // Value of filter order date from
      dateFrom: null,
      // Value of filter order date to
      dateTo: null
    };
    cov_x7cnmwq6a().s[9]++;
    _this.generateReport = _this.generateReport.bind((0, _assertThisInitialized2.default)(_this));
    cov_x7cnmwq6a().s[10]++;
    _this.buildReportGenerateParamUrl = _this.buildReportGenerateParamUrl.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }
  (0, _createClass2.default)(ReportManagement, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      var _this2 = this;
      cov_x7cnmwq6a().f[3]++;
      cov_x7cnmwq6a().s[11]++;
      // Update selectReportId when props reportVariants change
      // In case current selectReportId not in next props reportVariants => Update it
      if (this.props.reportVariants.filter(function (report) {
        cov_x7cnmwq6a().f[4]++;
        cov_x7cnmwq6a().s[12]++;
        return report.reportId === _this2.state.selectReportId;
      }).length > 0) {
        cov_x7cnmwq6a().b[3][0]++;
        cov_x7cnmwq6a().s[13]++;
        return;
      } else {
        cov_x7cnmwq6a().b[3][1]++;
      }
      // eslint-disable-next-line react/no-did-update-set-state
      cov_x7cnmwq6a().s[14]++;
      this.setState(function (state) {
        cov_x7cnmwq6a().f[5]++;
        cov_x7cnmwq6a().s[15]++;
        return _objectSpread(_objectSpread({}, state), {}, {
          selectReportId: (0, _get.default)(_this2.props, 'reportVariants[0].reportId', null)
        });
      });
    }
  }, {
    key: "generateReport",
    value: function () {
      var _generateReport = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(exportType, urlPath) {
        var generateUrl;
        return _regenerator.default.wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              cov_x7cnmwq6a().f[24]++;
              cov_x7cnmwq6a().s[96]++;
              _context.next = 4;
              return this.buildReportGenerateParamUrl(exportType, urlPath);
            case 4:
              generateUrl = _context.sent;
              cov_x7cnmwq6a().s[97]++;
              window.open(generateUrl);
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function generateReport(_x, _x2) {
        return _generateReport.apply(this, arguments);
      }
      return generateReport;
    }()
  }, {
    key: "buildReportGenerateParamUrl",
    value: function () {
      var _buildReportGenerateParamUrl = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(exportType, urlPath) {
        var _ref4, seasonId, mainProducts, subProducts, productRange, isAllProductsWereSelected, generateAllId, isGenerateProductLevel, productType, reportTourLevel, _ref5, dateFrom, dateTo, isShowAlertOrderDate, isTourReport, tourIds, productIds, performanceIds, fromDateParam, toDateParam, performanceIdsParam, productIdsParam, generateIdParam, tourIdsParam, seasonIdParam, productFromDateParam, productToDateParam, generateProduct, _ref6, restHost, headers, exportTypeParam, params;
        return _regenerator.default.wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              cov_x7cnmwq6a().f[33]++;
              _ref4 = (cov_x7cnmwq6a().s[114]++, this.props), seasonId = _ref4.seasonId, mainProducts = _ref4.mainProducts, subProducts = _ref4.subProducts, productRange = _ref4.productRange, isAllProductsWereSelected = _ref4.isAllProductsWereSelected, generateAllId = _ref4.generateAllId, isGenerateProductLevel = _ref4.isGenerateProductLevel, productType = _ref4.productType, reportTourLevel = _ref4.reportTourLevel;
              _ref5 = (cov_x7cnmwq6a().s[115]++, this.state), dateFrom = _ref5.dateFrom, dateTo = _ref5.dateTo, isShowAlertOrderDate = _ref5.isShowAlertOrderDate;
              isTourReport = (cov_x7cnmwq6a().s[116]++, productType === 'TOUR');
              tourIds = (cov_x7cnmwq6a().s[117]++, []);
              productIds = (cov_x7cnmwq6a().s[118]++, []);
              performanceIds = (cov_x7cnmwq6a().s[119]++, []);
              fromDateParam = (cov_x7cnmwq6a().s[120]++, null);
              toDateParam = (cov_x7cnmwq6a().s[121]++, null);
              performanceIdsParam = (cov_x7cnmwq6a().s[122]++, null);
              productIdsParam = (cov_x7cnmwq6a().s[123]++, null);
              generateIdParam = (cov_x7cnmwq6a().s[124]++, null);
              tourIdsParam = (cov_x7cnmwq6a().s[125]++, null);
              seasonIdParam = (cov_x7cnmwq6a().s[126]++, seasonId);
              productFromDateParam = (cov_x7cnmwq6a().s[127]++, productRange.firstDate ? (cov_x7cnmwq6a().b[32][0]++, this.formatDate(productRange.firstDate)) : (cov_x7cnmwq6a().b[32][1]++, null));
              productToDateParam = (cov_x7cnmwq6a().s[128]++, productRange.lastDate ? (cov_x7cnmwq6a().b[33][0]++, this.formatDate(productRange.lastDate)) : (cov_x7cnmwq6a().b[33][1]++, null)); // If not pass generateAllId => keep default behavior => generate by product ids
              cov_x7cnmwq6a().s[129]++;
              if ((cov_x7cnmwq6a().b[35][0]++, !isAllProductsWereSelected) || (cov_x7cnmwq6a().b[35][1]++, isAllProductsWereSelected) && (cov_x7cnmwq6a().b[35][2]++, !generateAllId)) {
                cov_x7cnmwq6a().b[34][0]++;
                generateProduct = (cov_x7cnmwq6a().s[130]++, (0, _size.default)(mainProducts) > 0 ? (cov_x7cnmwq6a().b[36][0]++, mainProducts) : (cov_x7cnmwq6a().b[36][1]++, subProducts));
                cov_x7cnmwq6a().s[131]++;
                if ((cov_x7cnmwq6a().b[38][0]++, isTourReport) && (cov_x7cnmwq6a().b[38][1]++, _helpers.TOUR_REPORT_LEVEL_ENUM.TOUR === reportTourLevel)) {
                  cov_x7cnmwq6a().b[37][0]++;
                  cov_x7cnmwq6a().s[132]++;
                  tourIds = this.getTourIdsForUrl(mainProducts);
                } else {
                  cov_x7cnmwq6a().b[37][1]++;
                  cov_x7cnmwq6a().s[133]++;
                  productIds = this.getProductIdsForUrl(generateProduct);
                  cov_x7cnmwq6a().s[134]++;
                  performanceIds = (0, _size.default)(subProducts) > 0 ? (cov_x7cnmwq6a().b[39][0]++, this.getSubProductIdsForUrl(subProducts)) : (cov_x7cnmwq6a().b[39][1]++, []);
                }
              } else {
                cov_x7cnmwq6a().b[34][1]++;
              }
              // Just send order date
              // - Date from or date to were selected (have value)
              // - Select report variants have param order date (not show alert order date)
              cov_x7cnmwq6a().s[135]++;
              if ((cov_x7cnmwq6a().b[41][0]++, !isShowAlertOrderDate) && ((cov_x7cnmwq6a().b[41][1]++, dateFrom) || (cov_x7cnmwq6a().b[41][2]++, dateTo))) {
                cov_x7cnmwq6a().b[40][0]++;
                cov_x7cnmwq6a().s[136]++;
                fromDateParam = dateFrom ? (cov_x7cnmwq6a().b[42][0]++, this.formatDate(dateFrom)) : (cov_x7cnmwq6a().b[42][1]++, null);
                cov_x7cnmwq6a().s[137]++;
                toDateParam = dateTo ? (cov_x7cnmwq6a().b[43][0]++, this.formatDate(dateTo)) : (cov_x7cnmwq6a().b[43][1]++, null);
              } else {
                cov_x7cnmwq6a().b[40][1]++;
              }

              // For tour report: only generate id param for PRODUCT, PERFORMANCE, VISIT level
              cov_x7cnmwq6a().s[138]++;
              if (!((cov_x7cnmwq6a().b[45][0]++, isAllProductsWereSelected) && (cov_x7cnmwq6a().b[45][1]++, generateAllId))) {
                _context2.next = 27;
                break;
              }
              cov_x7cnmwq6a().b[44][0]++;
              cov_x7cnmwq6a().s[139]++;
              generateIdParam = generateAllId;
              _context2.next = 32;
              break;
            case 27:
              cov_x7cnmwq6a().b[44][1]++;
              _ref6 = (cov_x7cnmwq6a().s[140]++, this.props.requestConfig), restHost = _ref6.restHost, headers = _ref6.headers; // STX-99636: Call backend to save generate params in session server => return id to generate in client-side
              cov_x7cnmwq6a().s[141]++;
              _context2.next = 32;
              return (0, _axios.default)("".concat(restHost, "/v1/report/saveReportGenerationParams"), {
                method: 'POST',
                headers: headers,
                data: {
                  productIds: productIds,
                  performanceIds: performanceIds,
                  tourIds: tourIds
                }
              }).then(function (response) {
                cov_x7cnmwq6a().f[34]++;
                cov_x7cnmwq6a().s[142]++;
                if (response.status === 200) {
                  cov_x7cnmwq6a().b[46][0]++;
                  cov_x7cnmwq6a().s[143]++;
                  generateIdParam = response.data.id;
                } else {
                  cov_x7cnmwq6a().b[46][1]++;
                  cov_x7cnmwq6a().s[144]++;
                  // STX-99636: In case request failed => use old behavior is pass params to request URL
                  productIdsParam = productIds.join(',');
                  cov_x7cnmwq6a().s[145]++;
                  performanceIdsParam = performanceIds.join(',');
                  cov_x7cnmwq6a().s[146]++;
                  tourIdsParam = tourIds.join(',');
                }
              });
            case 32:
              exportTypeParam = (cov_x7cnmwq6a().s[147]++, (cov_x7cnmwq6a().b[47][0]++, exportType) || (cov_x7cnmwq6a().b[47][1]++, _Styling.ExportType.PDF));
              params = (cov_x7cnmwq6a().s[148]++, {
                generateId: generateIdParam,
                tourIds: tourIdsParam,
                productIds: productIdsParam,
                performanceIds: performanceIdsParam,
                fromDate: fromDateParam,
                toDate: toDateParam,
                productFromDate: productFromDateParam,
                productToDate: productToDateParam,
                seasonId: seasonIdParam,
                exportType: exportTypeParam,
                isGenerateProductLevel: isGenerateProductLevel
              });
              cov_x7cnmwq6a().s[149]++;
              return _context2.abrupt("return", (0, _utils.buildUrl)(urlPath, params));
            case 36:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
      function buildReportGenerateParamUrl(_x3, _x4) {
        return _buildReportGenerateParamUrl.apply(this, arguments);
      }
      return buildReportGenerateParamUrl;
    }()
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      cov_x7cnmwq6a().f[36]++;
      var _ref7 = (cov_x7cnmwq6a().s[153]++, this.props),
        reportVariants = _ref7.reportVariants,
        isDisable = _ref7.isDisable,
        mainProducts = _ref7.mainProducts,
        subProducts = _ref7.subProducts,
        productRange = _ref7.productRange,
        productType = _ref7.productType,
        isAllProductsWereSelected = _ref7.isAllProductsWereSelected,
        isShowAlertNotSameLevel = _ref7.isShowAlertNotSameLevel,
        isShowDateRangeInterrupted = _ref7.isShowDateRangeInterrupted,
        isShowDifferenceProduct = _ref7.isShowDifferenceProduct,
        intl = _ref7.intl,
        isHelpIconVisible = _ref7.isHelpIconVisible,
        unselectedPerformanceIds = _ref7.unselectedPerformanceIds,
        reportTourLevel = _ref7.reportTourLevel;
      var _ref8 = (cov_x7cnmwq6a().s[154]++, this.state),
        dateFrom = _ref8.dateFrom,
        dateTo = _ref8.dateTo,
        selectReportId = _ref8.selectReportId,
        isShowAlertOrderDate = _ref8.isShowAlertOrderDate,
        isShowAlertSelectProduct = _ref8.isShowAlertSelectProduct,
        isOrderDateChange = _ref8.isOrderDateChange;
      var currentTourProductLevel = (cov_x7cnmwq6a().s[155]++, (0, _keys.default)(_helpers.TOUR_REPORT_LEVEL_ENUM).find(function (key) {
        cov_x7cnmwq6a().f[37]++;
        cov_x7cnmwq6a().s[156]++;
        return _helpers.TOUR_REPORT_LEVEL_ENUM[key] === reportTourLevel;
      }));
      var message = (cov_x7cnmwq6a().s[157]++, {
        title: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.title',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 484,
            columnNumber: 14
          }
        }),
        allItems: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.SummaryItem.allItems',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 485,
            columnNumber: 17
          }
        }),
        generateFor: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.SummaryItem.generateFor',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 486,
            columnNumber: 20
          }
        }),
        selectedItems: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.SummaryItem.selectedItems',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 487,
            columnNumber: 22
          }
        }),
        generateButton: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.generateButton',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 488,
            columnNumber: 23
          }
        }),
        splitButtonText: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.splitButtonText',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 489,
            columnNumber: 24
          }
        }),
        selectAtLeastProduct: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.selectAtLeastProduct',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 490,
            columnNumber: 29
          }
        }),
        viewPdfButton: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.viewPdfButton',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 491,
            columnNumber: 22
          }
        }),
        alertOrderDateCompatible: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.reportOrderDateNotCompatible',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 492,
            columnNumber: 33
          }
        }),
        orderDateFrom: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.orderDateFrom',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 493,
            columnNumber: 22
          }
        }),
        orderDateTo: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.orderDateTo',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 494,
            columnNumber: 20
          }
        }),
        noReportManage: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.noReportManage',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 495,
            columnNumber: 23
          }
        }),
        from: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.DateRange.from',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 496,
            columnNumber: 13
          }
        }),
        to: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.DateRange.to',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 497,
            columnNumber: 11
          }
        }),
        notSameLevelProduct: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.notSameLevel',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 498,
            columnNumber: 28
          }
        }),
        dateRangeInterrupted: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.alertInterruptDateRange',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 499,
            columnNumber: 29
          }
        }),
        differenceProduct: /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
          id: 'gravity.ReportManagement.differenceProduct',
          __self: this,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 500,
            columnNumber: 26
          }
        }),
        currentTourProductLevel: ((cov_x7cnmwq6a().b[48][0]++, reportTourLevel === 0) || (cov_x7cnmwq6a().b[48][1]++, reportTourLevel)) && (cov_x7cnmwq6a().b[48][2]++, intl.formatMessage({
          id: "gravity.ReportManagement.tourLevel.".concat((cov_x7cnmwq6a().b[49][0]++, currentTourProductLevel) && (cov_x7cnmwq6a().b[49][1]++, currentTourProductLevel.toLowerCase()))
        })),
        selectReport: intl.formatMessage({
          id: 'gravity.ProducerDashboard.helpInfo.selectReport'
        }),
        reportFilter: intl.formatMessage({
          id: 'gravity.ProducerDashboard.helpInfo.reportFilter'
        }),
        generateReport: intl.formatMessage({
          id: 'gravity.ProducerDashboard.helpInfo.generateReport'
        })
      });

      // Just display report function if params have report variants data
      var isReportAvailable = (cov_x7cnmwq6a().s[158]++, (0, _size.default)(reportVariants) > 0);
      var isGenerateForEvent = (cov_x7cnmwq6a().s[159]++, productType === _product.ProductTypeEnum.EVENT);
      var reportItemSummary;
      cov_x7cnmwq6a().s[160]++;
      if (isGenerateForEvent) {
        cov_x7cnmwq6a().b[50][0]++;
        cov_x7cnmwq6a().s[161]++;
        reportItemSummary = this.getReportSummaryForEvent(mainProducts, subProducts, message, isAllProductsWereSelected, unselectedPerformanceIds);
      } else {
        cov_x7cnmwq6a().b[50][1]++;
        cov_x7cnmwq6a().s[162]++;
        if (productType === _product.ProductTypeEnum.VISIT) {
          cov_x7cnmwq6a().b[51][0]++;
          cov_x7cnmwq6a().s[163]++;
          reportItemSummary = this.getReportSummaryForVisit(mainProducts, productRange, message, isAllProductsWereSelected);
        } else {
          cov_x7cnmwq6a().b[51][1]++;
          cov_x7cnmwq6a().s[164]++;
          reportItemSummary = this.getReportSummaryForPass(mainProducts, message, isAllProductsWereSelected);
        }
      }

      // Check disable date filter to prevent trigger any event that show the popup
      var isDisableDateFilter = (cov_x7cnmwq6a().s[165]++, this.isShouldDisableDateFilter(selectReportId));
      var dateFilterFrom = (cov_x7cnmwq6a().s[166]++, /*#__PURE__*/_react.default.createElement(_Styling.DateFilterWrapper, {
        date: dateFrom,
        defaultText: message.orderDateFrom,
        onDateChange: function onDateChange(changeDate) {
          cov_x7cnmwq6a().f[38]++;
          cov_x7cnmwq6a().s[167]++;
          return _this3.onChangeOrderDate(changeDate, true);
        },
        isDisable: isDisableDateFilter,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 525,
          columnNumber: 7
        }
      }));
      // Pass hideBeforeDate to hide the days before date from => Prevent select incorrect date
      var dateFilterTo = (cov_x7cnmwq6a().s[168]++, /*#__PURE__*/_react.default.createElement(_Styling.DateFilterWrapper, {
        date: dateTo,
        defaultText: message.orderDateTo,
        onDateChange: function onDateChange(changeDate) {
          cov_x7cnmwq6a().f[39]++;
          cov_x7cnmwq6a().s[169]++;
          return _this3.onChangeOrderDate(changeDate, false);
        },
        isDisable: isDisableDateFilter,
        hideBeforeDate: (cov_x7cnmwq6a().b[52][0]++, dateFrom !== null) && (cov_x7cnmwq6a().b[52][1]++, dateFrom),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 534,
          columnNumber: 7
        }
      }));
      var resetOrderDateBtn = (cov_x7cnmwq6a().s[170]++, /*#__PURE__*/_react.default.createElement(_Styling.ResetButton, {
        onClick: this.resetOrderDateFilter,
        disabled: (cov_x7cnmwq6a().b[53][0]++, !isOrderDateChange) || (cov_x7cnmwq6a().b[53][1]++, isShowAlertOrderDate),
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 544,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        size: 20,
        iconName: 'close',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 548,
          columnNumber: 9
        }
      })));

      // Message to inform user that selected report not have order date filter
      var alertOrderDate = (cov_x7cnmwq6a().s[171]++, /*#__PURE__*/_react.default.createElement(_Styling.AlertOrderDateCompatibleWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 554,
          columnNumber: 7
        }
      }, message.alertOrderDateCompatible));
      cov_x7cnmwq6a().s[172]++;
      var handleReportDropdownVariantChange = function handleReportDropdownVariantChange(event) {
        cov_x7cnmwq6a().f[40]++;
        cov_x7cnmwq6a().s[173]++;
        return _this3.onDropdownSelect(event.target.value);
      };
      var reportVariantsDropdown = (cov_x7cnmwq6a().s[174]++, /*#__PURE__*/_react.default.createElement(_Styling.DropDownWrapper, {
        "data-intro": "5. ".concat(message.selectReport),
        "data-sequence": '5',
        "data-position": 'bottom',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 561,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_dropdown.default, {
        onChange: handleReportDropdownVariantChange,
        onSelect: handleReportDropdownVariantChange,
        value: selectReportId,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 566,
          columnNumber: 9
        }
      }, reportVariants.map(function (reportVariant) {
        cov_x7cnmwq6a().f[41]++;
        cov_x7cnmwq6a().s[175]++;
        return /*#__PURE__*/_react.default.createElement("option", {
          key: reportVariant.reportId,
          value: reportVariant.reportId,
          __self: _this3,
          __source: {
            fileName: _jsxFileName,
            lineNumber: 572,
            columnNumber: 13
          }
        }, reportVariant.reportName);
      }), (cov_x7cnmwq6a().b[54][0]++, (0, _size.default)(reportVariants) === 0) && (cov_x7cnmwq6a().b[54][1]++, /*#__PURE__*/_react.default.createElement("option", {
        value: "",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 576,
          columnNumber: 42
        }
      }, message.noReportManage)))));
      var alertSelectProduct = (cov_x7cnmwq6a().s[176]++, this.getAlertMessage(message.selectAtLeastProduct, message.currentTourProductLevel));
      var alertNotSameLevelProduct = (cov_x7cnmwq6a().s[177]++, this.getAlertMessage(message.notSameLevelProduct, message.currentTourProductLevel));
      var isShowReportItem = (cov_x7cnmwq6a().s[178]++, (cov_x7cnmwq6a().b[55][0]++, isReportAvailable) && (cov_x7cnmwq6a().b[55][1]++, !isShowAlertNotSameLevel) && (cov_x7cnmwq6a().b[55][2]++, !isShowAlertSelectProduct) && (cov_x7cnmwq6a().b[55][3]++, !isShowDifferenceProduct) && (cov_x7cnmwq6a().b[55][4]++, !isShowDateRangeInterrupted));
      var alertMessageDisplay = (cov_x7cnmwq6a().s[179]++, '');
      cov_x7cnmwq6a().s[180]++;
      if (isShowAlertNotSameLevel) {
        cov_x7cnmwq6a().b[56][0]++;
        cov_x7cnmwq6a().s[181]++;
        alertMessageDisplay = alertNotSameLevelProduct;
      } else {
        cov_x7cnmwq6a().b[56][1]++;
        cov_x7cnmwq6a().s[182]++;
        if (isShowAlertSelectProduct) {
          cov_x7cnmwq6a().b[57][0]++;
          cov_x7cnmwq6a().s[183]++;
          alertMessageDisplay = alertSelectProduct;
        } else {
          cov_x7cnmwq6a().b[57][1]++;
          cov_x7cnmwq6a().s[184]++;
          if (isShowDateRangeInterrupted) {
            cov_x7cnmwq6a().b[58][0]++;
            cov_x7cnmwq6a().s[185]++;
            alertMessageDisplay = this.getAlertMessage(message.dateRangeInterrupted);
          } else {
            cov_x7cnmwq6a().b[58][1]++;
            cov_x7cnmwq6a().s[186]++;
            if (isShowDifferenceProduct) {
              cov_x7cnmwq6a().b[59][0]++;
              cov_x7cnmwq6a().s[187]++;
              alertMessageDisplay = this.getAlertMessage(message.differenceProduct);
            } else {
              cov_x7cnmwq6a().b[59][1]++;
            }
          }
        }
      }
      var isDisableGenerateBtn = (cov_x7cnmwq6a().s[188]++, (cov_x7cnmwq6a().b[60][0]++, isDisable) || (cov_x7cnmwq6a().b[60][1]++, (0, _size.default)(reportVariants) === 0) || (cov_x7cnmwq6a().b[60][2]++, isShowAlertNotSameLevel) || (cov_x7cnmwq6a().b[60][3]++, !isShowReportItem));
      var generateButton = (cov_x7cnmwq6a().s[189]++, /*#__PURE__*/_react.default.createElement(_Styling.ButtonWrapper, {
        isDisable: isDisableGenerateBtn,
        className: 'report-btn-generate',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 605,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: function onClick() {
          cov_x7cnmwq6a().f[42]++;
          cov_x7cnmwq6a().s[190]++;
          return _this3.onGenerateButtonClick(_Styling.ExportType.EXCEL, isDisableGenerateBtn);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 606,
          columnNumber: 9
        }
      }, message.generateButton)));
      var splitButtonText = (cov_x7cnmwq6a().s[191]++, /*#__PURE__*/_react.default.createElement(_Styling.SplitButtonTextWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 613,
          columnNumber: 7
        }
      }, message.splitButtonText));
      var viewPdfButton = (cov_x7cnmwq6a().s[192]++, /*#__PURE__*/_react.default.createElement(_Styling.ButtonWrapper, {
        isDisable: isDisableGenerateBtn,
        className: 'report-btn-view-pdf',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 617,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_button.default, {
        onClick: function onClick() {
          cov_x7cnmwq6a().f[43]++;
          cov_x7cnmwq6a().s[193]++;
          return _this3.onGenerateButtonClick(_Styling.ExportType.PDF, isDisableGenerateBtn);
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 618,
          columnNumber: 9
        }
      }, message.viewPdfButton)));
      var helpButton = (cov_x7cnmwq6a().s[194]++, /*#__PURE__*/_react.default.createElement(_Styling.HelpButton, {
        onClick: this.toggleHelp,
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 625,
          columnNumber: 7
        }
      }, /*#__PURE__*/_react.default.createElement(_icon.default, {
        iconName: "help",
        iconColor: function iconColor(props) {
          cov_x7cnmwq6a().f[44]++;
          cov_x7cnmwq6a().s[195]++;
          return (0, _get.default)(props.theme, 'dashboard.contentTextColor', '#1a84f1');
        },
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 626,
          columnNumber: 9
        }
      }), /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedHTMLMessage, {
        id: "gravity.ProducerDashboard.helpIcon",
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 627,
          columnNumber: 9
        }
      })));
      var heading = (cov_x7cnmwq6a().s[196]++, /*#__PURE__*/_react.default.createElement(_Styling.SectionHeading, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 632,
          columnNumber: 7
        }
      }, message.title, alertMessageDisplay, (cov_x7cnmwq6a().b[61][0]++, isShowReportItem) && (cov_x7cnmwq6a().b[61][1]++, reportItemSummary), (cov_x7cnmwq6a().b[62][0]++, isHelpIconVisible) && (cov_x7cnmwq6a().b[62][1]++, helpButton)));
      cov_x7cnmwq6a().s[197]++;
      return /*#__PURE__*/_react.default.createElement(_Styling.Wrapper, (0, _extends2.default)({}, this.props, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 641,
          columnNumber: 7
        }
      }), heading, (cov_x7cnmwq6a().b[63][0]++, !isReportAvailable) && (cov_x7cnmwq6a().b[63][1]++, /*#__PURE__*/_react.default.createElement(_Styling.AlertNoReportAvailable, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 645,
          columnNumber: 11
        }
      }, message.noReportManage)), (cov_x7cnmwq6a().b[64][0]++, isReportAvailable) && (cov_x7cnmwq6a().b[64][1]++, /*#__PURE__*/_react.default.createElement(_Styling.FlexReportAreaWrapper, {
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 649,
          columnNumber: 11
        }
      }, /*#__PURE__*/_react.default.createElement(_Styling.FlexReportAreaWrapper, {
        width: 'auto',
        "data-intro": "4. ".concat(message.reportFilter),
        "data-sequence": '4',
        "data-position": 'top:-50',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 650,
          columnNumber: 13
        }
      }, dateFilterFrom, dateFilterTo, resetOrderDateBtn), /*#__PURE__*/_react.default.createElement(_Styling.FlexReportAreaWrapper, {
        width: 'auto',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 660,
          columnNumber: 13
        }
      }, reportVariantsDropdown, /*#__PURE__*/_react.default.createElement(_Styling.GenerateBtnArea, {
        "data-intro": "6. ".concat(message.generateReport),
        "data-sequence": '6',
        "data-position": 'top',
        __self: this,
        __source: {
          fileName: _jsxFileName,
          lineNumber: 662,
          columnNumber: 15
        }
      }, viewPdfButton, splitButtonText, generateButton)), (cov_x7cnmwq6a().b[65][0]++, isShowAlertOrderDate) && (cov_x7cnmwq6a().b[65][1]++, alertOrderDate))));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(props, preState) {
      cov_x7cnmwq6a().f[1]++;
      cov_x7cnmwq6a().s[5]++;
      return _objectSpread(_objectSpread({}, preState), {}, {
        isShowAlertSelectProduct: updateAlertSelectProduct(props.productType, props.mainProducts, props.subProducts, props.productRange, preState.isShowAlertSelectProduct)
      });
    }
  }]);
  return ReportManagement;
}(_react.PureComponent);
cov_x7cnmwq6a().s[198]++;
ReportManagement.propTypes = {
  /* Report variants data */
  reportVariants: _propTypes.default.arrayOf(_propTypes.default.object).isRequired,
  /* Generate URL to call generate report */
  reportGenerateUrl: _propTypes.default.string.isRequired,
  /* List of main product data need to generate report */
  mainProducts: _propTypes.default.arrayOf(_propTypes.default.object),
  /* List of sub product data need to generate report */
  subProducts: _propTypes.default.arrayOf(_propTypes.default.object),
  /* Season id */
  seasonId: _propTypes.default.number,
  /* Should disable to prevent user select or not */
  isDisable: _propTypes.default.bool,
  /* Date range when generate visit product */
  productRange: _propTypes.default.shape({}),
  /* Type of product that going to be generated */
  productType: _propTypes.default.oneOf((0, _values.default)(_product.ProductTypeEnum)),
  /* Should show alert not same level */
  isShowAlertNotSameLevel: _propTypes.default.bool,
  /* Pass TRUE if does not have any product is selected (to generate), otherwise FALSE - Mainly use for show alert message */
  isNoneProductWereSelected: _propTypes.default.bool,
  /* Pass TRUE if all products are selected (to generate), otherwise FALSE */
  isAllProductsWereSelected: _propTypes.default.bool,
  /* Should show alert not able to generate for difference level products */
  isShowDifferenceProduct: _propTypes.default.bool,
  /* Should show alert date range interrupted */
  isShowDateRangeInterrupted: _propTypes.default.bool,
  /* Generate all ID */
  generateAllId: _propTypes.default.number,
  /* Pass TRUE if generate for product level, otherwise FALSE */
  isGenerateProductLevel: _propTypes.default.bool,
  /* Validation for react-intl */
  intl: _reactIntl.intlShape.isRequired,
  /* Show help icon */
  isHelpIconVisible: _propTypes.default.bool,
  /* Config for call REST API (restHost + headers) */
  requestConfig: _propTypes.default.shape({}),
  /* List of unselected performances */
  unselectedPerformanceIds: _propTypes.default.arrayOf(_propTypes.default.number),
  /* Level to indicate what product type should be generated */
  reportTourLevel: _propTypes.default.number
};
cov_x7cnmwq6a().s[199]++;
ReportManagement.defaultProps = {
  mainProducts: [],
  subProducts: [],
  seasonId: null,
  isDisable: false,
  isAllProductsWereSelected: false,
  productRange: {},
  isNoneProductWereSelected: false,
  productType: 'EVENT',
  isShowAlertNotSameLevel: false,
  isShowDifferenceProduct: false,
  isShowDateRangeInterrupted: false,
  generateAllId: null,
  isGenerateProductLevel: false,
  isHelpIconVisible: false,
  requestConfig: {},
  unselectedPerformanceIds: [],
  reportTourLevel: _helpers.TOUR_REPORT_LEVEL_ENUM.TOUR
};
var _default = exports.default = (0, _reactIntl.injectIntl)(ReportManagement);